export const en = {
    dashboard: 'Dashboard',
    items_selected: 'items selected',
    menu: 'Menu',
    back: 'Back',
    edit: 'Edit',
    create: 'Create',
    create_and_view: 'Create and view',
    create_and_edit: 'Create and edit',
    filters: 'Filters',
    clear: 'Clear',
    update: 'Update',
    load_defaults: 'Load defaults',
    close: 'Close',
    apply: 'Apply',
    proceed: 'Proceed',
    delete: 'Delete',
    actions: 'Actions',
    cancel: 'Cancel',
    select: 'Select',
    fill: 'Fill',
    description: 'Description',
    platform_name: 'Platform Name',
    sub_platform_name: 'Sub Platform Name',
    parent_platform_name: 'Parent Platform',
    platform: 'Platform',
    platforms: 'Platforms',
    platform_uid: 'Platform ID',
    create_platform: 'Create Platform',
    url: 'URL',
    summary: 'Summary',
    clearing_system: 'Clearing System',
    clearing_systems: 'Clearing Systems',
    clearing_system_ci: 'Crowd Investing',
    clearing_system_cf: 'Crowd Funding',
    clearing_system_emission: 'Emission',
    clearing_system_stock_emission: 'Stock Emission',
    terms: 'Terms and conditions',
    privacy_policy: 'Privacy Policy',
    platform_attachments: 'Platform Attachments',
    platform_documents: 'Platform Documents',
    platform_document: 'Platform document',
    linked_platform_documents: 'Linked Platform Documents',
    select_all: 'Select all',
    id: 'ID',
    name: 'Name',
    type: 'Type',
    file: 'File',
    choose_file: 'Choose file',
    choose_image: 'Choose image',
    no_document_uploaded: 'No document uploaded',
    reset: 'Reset',
    information_letter: 'Information letter',
    platform_webhooks: 'Platform Webhooks',
    platform_webhook: 'Platform Webhook',
    event: 'Event',
    secret: 'Secret',
    platform_policies: 'Platform Policies',
    platform_policy: 'Platform Policy',
    platform_cookie_consent_services: 'Cookie Consent Services',
    platform_cookie_consent_service: 'Cookie Consent Service',
    provider_key: 'Provider',
    enabled: 'Enabled',
    country: 'Country',
    countries: 'Countries',
    language: 'Language',
    content: 'Content',
    platform_email_templates: 'Platform Email Templates',
    subject: 'Subject',
    placeholders: 'Placeholders',
    insert: 'Insert',
    platform_disclaimer: 'Platform Disclaimer',
    platform_disclaimers: 'Platform Disclaimers',
    countries_applied: 'Applied in',
    countries_not_applied: 'Not applied in',
    platform_details: 'Platform details',
    platform_logo: 'Logo',
    links: 'Links',
    privacy_url: 'Privacy Policy',
    email_settings: 'Email Settings',
    admin_email: 'Admin Email',
    mail_template: 'Email Template',
    order_status_for_total_funding_sum: 'Total Funding Sum',
    pending: 'Pending',
    paid: 'Paid',
    accepted: 'Accepted',
    smtp_settings: 'SMTP Settings',
    mail_host: 'SMTP Server',
    mail_port: 'SMTP Port',
    mail_encryption: 'Encryption',
    none: 'None',
    mail_from_address: 'Sender Email',
    mail_form_name: 'Sender Name',
    mail_username: 'SMTP Username',
    mail_password: 'SMTP Password',
    assets: 'Assets',
    asset: 'Asset',
    asset_name: 'Assets Name',
    currency: 'Currency',
    create_asset: 'Create Asset',
    asset_title: 'Asset Title',
    asset_details: 'Asset details',
    asset_category: 'Asset category',
    asset_class: 'Asset Class',
    help_asset_class: 'The asset class.',
    asset_regulation: 'Asset Regulation',
    asset_jurisdiction: 'Asset Jurisdiction',
    is_subordinated: 'Subordinated',
    is_tied_agent: 'Gebundener Vermittler',
    return_calculator: 'Renditerechner',
    return_calculator_active: 'Renditerechner aktiv',
    transferable: 'Transferable',
    transfer_restriction: 'Transfer Restriction',
    pre_money_valuation: 'Pre-Money Valuation',
    equity_percentage: 'Equity Percentage',
    dividend_preference_pct: 'Dividend Preference (%)',
    cooperative_registry_number: 'Cooperative Registry Number',
    cooperative_statute_url: 'Cooperative Statute URL',
    cooperative_notice_period: 'Notice Period',
    cooperative_additional_contribution: 'Additional Contribution Obligation',
    cooperative_mandatory_shares: 'Mandatory Shares',
    spv_legal_form: 'SPV Legal Form',
    spv_participation_quota_pct: 'SPV Participation Quota (%)',
    spv_participation_exemption: 'Participation Exemption',
    spv_corporate_tax_rate: 'SPV Corporate Tax Rate (%)',
    spv_lead_investor: 'Lead Investor',
    asset_location: 'Asset Location',
    asset_location_state: 'State',
    asset_location_country: 'Country',
    city: 'City',
    state: 'State',
    asset_funding_limits: 'Funding limits',
    asset_funding_min: 'Funding minimum',
    asset_funding_max: 'Funding maximum',
    asset_investment_min: 'Investment minimum',
    asset_investment_max: 'Investment maximum',
    asset_step_level: 'Investment step level',
    asset_quick_amounts: 'Quick amounts',
    asset_base_funding_count: 'Base Investments Count',
    asset_base_funding_total: 'Base Investment Amount',
    base_funding_total: 'Investment Amount',
    manual_funding_totals: 'Manual Funding Totals',
    asset_manual_funding_totals: 'Manual Funding Totals',
    automatic_payments: 'Automatic Payments',
    asset_deactivate_payment_account: 'Deactivate automatic payments',
    asset_documents: 'Asset Documents',
    asset_documents_contract_data: 'Contract Details',
    asset_documents_0: 'Contract Data',
    asset_documents_1: 'Reporting',
    asset_documents_2: 'Consumer Information',
    asset_price_per_stock: 'Price Per Stock',
    asset_minimum_investment: 'Minimum Investment',
    asset_minimum_shares: 'Minimum Shares',
    asset_stock_increments: 'Stock Increments',
    asset_number_of_stocks: 'Number of Stocks',
    asset_maximum_total_investment_value: 'Maximum Total Investment Value',
    asset_stock_type: 'Stock Type',
    asset_nominal_value: 'Nominal Value',
    asset_agio: 'Agio',
    asset_isin: 'ISIN',
    asset_types: 'Asset Types',
    help_asset_price_per_stock:
        'Price per stock. Shown on the campaign card as the first box for share and cooperative share.',
    help_asset_minimum_investment:
        'Minimum investment value. This should be exact multiplication of stock price. ',
    help_asset_minimum_shares: 'Minimum Investment in Shares',
    help_asset_stock_increments: 'Stock Increments',
    help_asset_number_of_stocks: 'Number of Stocks',
    help_asset_maximum_total_investment_value: 'Maximum Total Investment Value',
    help_asset_stock_type: 'Stock Type',
    help_asset_isin: 'ISIN',
    company_details: 'Company Details',
    company_name: 'Company Name',
    company_logo: 'Company Logo',
    address: 'Address',
    postal_code: 'Postal Code',
    phone_number: 'Phone Number',
    email: 'Email',
    company_website: 'Company Website',
    iban: 'IBAN',
    bic: 'BIC',
    contract: 'Contract',
    contracts: 'Contracts',
    contract_details: 'Contract Details',
    contract_range: 'Contract Range',
    contract_editor: 'Contract Editor',
    interest_rate: 'Interest Rate',
    target_yield: 'Target Yield',
    signatures: 'Signatures',
    signature_documents: 'Signature Documents',
    add_signature_document: 'Add Signature Document',
    signature_type: 'Signature Type',
    signature_types: 'Signature Types',
    signature_type_manual: 'Manual',
    signature_manual_confirmation_required:
        'Confirmation required before acceptance',
    signature_type_sproof: 'Sproof',
    signature_type_signteq: 'Signteq',
    asset_signature_legal_notice: 'Signature Legal Notice',
    contract_type: 'Contract Type',
    contract_type_cash: 'Cash',
    contract_type_voucher: 'Voucher',
    contract_payment_start_date: 'Payment Start Date',
    contract_next_payment_date: 'Next Payment Date',
    payment_date: 'Payment Date',
    contract_period_type_fixed: 'Fixed',
    asset_document_type_0: 'Contract Data',
    asset_document_type_1: 'Reporting',
    asset_document_type_2: 'Consumer Information',
    asset_signature_document: 'Emission Signature Document',
    asset_signature_document_name: 'Emission Signature Document Name',
    help_asset_signature_document_name: 'Name of Emission Signature Document',
    platform_signteq_signature_organization_id: 'Signature Organization ID',
    help_platform_signteq_signature_organization_id:
        'Organization ID with the Signteq signature will be sent',
    asset_signature_signteq_subject: 'Signature subject',
    help_asset_signature_signteq_subject:
        'Subject of the Signteq signature. If empty, the campaign title will be used.',
    asset_signature_document_description:
        'Emission Signature Document Description',
    help_asset_signature_document_description:
        'Emission Signature Document Description',
    modal_title_delete_signature_documents:
        'Delete Emission Signature Document',
    modal_title_create_contract_template: 'Create contract document',
    modal_title_edit_contract_template: 'Edit contract document',
    signature_document_deleted: 'Signature document deleted',
    signature_document_uploaded: 'Signature document uploaded',
    transfer: 'Transfer',
    run_exclusive_acceptance: 'Run exclusive acceptance',
    start_process: 'Start process',
    no_payment_account_found: 'No payment account found.',
    wallet: 'Wallet',
    amount: 'Amount',
    date: 'Date',
    associate_orders: 'Associate orders',
    campaign: 'Campaign',
    campaigns: 'Campaigns',
    orders: 'Orders',
    order: 'Order',
    created_at: 'Created at',
    cancelled_at: 'Cancelled at',
    user_orders_list: 'Orders List',
    export_asset_investment_report: 'Export investment report',
    export_signature_documents: 'Export signature documents',
    upload_asset_investment_report: 'Upload investment report',
    upload_asset_secondary_market_import: 'Upload Secondary Market Import',
    export_asset_secondary_market_pre_emptive_rights:
        'SM - Export pre-emptive rights',
    export_check_orders_report: 'Export check orders report',
    send_ad_hoc_email_reminder: 'Send ad-hoc email reminder',
    transfer_tokens: 'Distribute Tokens',
    push_to_zoho: 'Push to Zoho',
    run_inclusive_acceptance: 'Run inclusive acceptance',
    open_baskets: 'View incomplete',
    basket_stage: 'Current stage',
    view_campaigns: 'View campaigns',
    status: 'Status',
    sub_status: 'Sub status',
    created_on: 'Created on',
    campaign_title: 'Campaign title',
    campaign_subtitle: 'Campaign subtitle',
    create_campaign: 'Create Campaign',
    campaign_details: 'Campaign details',
    campaign_summary: 'Campaign Summary',
    campaign_excerpt: 'Campaign Excerpt',
    funding_period: 'Funding Period',
    funding_start: 'Funding Start',
    funding_end: 'Funding End',
    waitlist_url: 'Waitlist URL',
    waitlist_text: 'Waitlist Text',
    regulatory_requirements: 'Regulatory Requirements',
    asset_regulation_override: 'Asset Regulation Override',
    is_co_placement: 'Co-Placement',
    agio_disagio: 'Agio/Disagio',
    agio_disagio_title: 'Agio/Disagio Title',
    agio_disagio_rate: 'Agio/Disagio Rate',
    agio_disagio_type: 'Agio/Disagio Type',
    agio_disagio_info_text: 'Agio/Disagio Infotext',
    agio_disagio_disclaimer: 'Agio/Disagio Disclaimer',
    agio_disagio_voucher: 'Voucher for Agio/Disagio',
    display_price_without_agio: 'Display price without agio/disagio',
    help_display_price_without_agio:
        'If enabled, the price will be displayed without agio/disagio.',
    savings_plan: 'Savings plan',
    savings_plan_description: 'Savings plan description',
    nyala_investment_id: 'Nyala investment ID',
    sync_nyala_investment: 'Sync Nyala Investment',
    create_nyala_investment: 'Create Nyala Investment',
    nyala_investment_error_sync:
        'Nyala Sync failed. {pendingOrdersCount} pending orders found:\n{pendingOrdersList}',
    voucher_code: 'Voucher Code',
    voucher_rate: 'Voucher Rate',
    country_and_language: 'Country and language',
    campaign_status: 'Campaign Status',
    funding_stats_visible: 'Display funding status',
    password: 'Password',
    broker: 'Broker',
    broker_status: 'Broker status',
    required_field: 'Required',
    purpose: 'Purpose',
    broker_disclaimer: 'Broker Disclaimer',
    external_project_page: 'External project page',
    external_project_url: 'External Project Page Link',
    badge: 'Badge',
    campaign_badge: 'Select badge',
    checkout: 'Checkout',
    show_amount_slider: 'Show amount slider',
    media: 'Media',
    campaign_thumb_image: 'Thumbnail',
    campaign_hero_image: 'Main Image',
    campaign_content: 'Campaign Content',
    main: 'Main',
    account_title: 'Account Title',
    content_images: 'Content images',
    content_documents: 'Content documents',
    loading: 'Loading',
    content_blocks: 'Content blocks',
    rank: 'Rank',
    title: 'Title',
    team_members: 'Team members',
    team_member: 'Team member',
    job_title: 'Job title',
    incentives: 'Incentives',
    funding: 'Funding',
    campaign_content_block_title: 'Name',
    campaign_content_block_content: 'Content',
    campaign_incentive_amount: 'Incentive amount',
    campaign_incentive_description: 'Incentive reward',
    campaign_incentive_title: 'Incentive  title',
    campaign_incentives_limit: 'Incentive Limit',
    campaign_team_member_name: 'Team member name',
    campaign_team_member_title: 'Team member title',
    campaign_team_member_bio: 'Team member bio',
    campaign_team_member_image: 'Team member picture.',
    wallet_status_title: 'Wallet Status',
    withdrawals: 'Withdrawals',
    withdrawal_amount: 'Amount',
    wallet_money_withdrawals: 'Money Withdrawals from Wallet',
    wallet_status_sc: 'SC Wallet',
    wallet_status_not_opened: 'Not opened',
    wallet_status_incomplete: 'Incomplete',
    wallet_status_rejected: 'Rejected',
    wallet_status_kyc1: 'KYC 1',
    wallet_status_kyc2: 'KYC 2',
    wallet_status_kyc3: 'KYC 3',
    wallet_status_expired: 'Expired',
    wallet_status_blocked: 'Blocked',
    wallet_status_closed: 'Closed',
    wallet_status_kyc_updating_2_3: 'Updating from KYC 2 to 3',
    wallet_status_ont_time_customer: 'One time customer',
    wallet_status_crowdlending: 'Crowdlending Wallet',
    wallet_status_technique: 'Technique Wallet',
    wallet_status_undefined: 'Account has no wallet',
    wallet_withdrawal_started_from_frontend: 'Was Started from Frontend',
    wallet_transactions: 'Wallet transactions',
    no_wallet_transactions: 'No wallet transactions',
    transaction_sender: 'Sender',
    transaction_receiver: 'Receiver',
    transaction_type: 'Transaction Type',
    transactions: 'Transactions',
    account: 'Investor',
    accounts: 'Investors',
    transfer_to: 'Transfer to',
    amount_of_shares: 'Amount of shares',
    further_transmissions: 'Further transmissions',
    natural_profile_active: 'Active',
    account_first_name: 'First Name',
    account_last_name: 'Last Name',
    account_email: 'Email',
    account_date_of_birth: 'Birthday',
    account_nationality: 'Nationality',
    account_default_language: 'Default language',
    account_country_of_birth: 'Country of birth',
    account_city_of_birth: 'City of birth',
    account_email_pending: 'Email pending',
    linked_natural_profiles: 'Linked Natural Profiles',
    natural_profiles: 'Natural Profiles',
    male: 'male',
    female: 'female',
    account_gender: 'Gender',
    account_custom_id: 'Custom ID',
    account_pep: 'Politically exposed person (PEP)',
    account_is_pep: 'yes',
    account_is_not_pep: 'no',
    account_nl_subscribed: 'Accepted Newsletter during signup',
    account_nl_is_subscribed: 'yes',
    account_nl_is_not_subscribed: 'no',
    account_address: 'Address',
    account_address_required_for_wallet: 'Address (Required for Wallet)',
    account_zip: 'Zip Code',
    account_zip_required_for_wallet: 'Zip Code (Required for Wallet)',
    account_country: 'Country',
    account_country_required_for_wallet: 'Country (Required for Wallet)',
    account_city: 'City',
    account_city_required_for_wallet: 'City (Required for Wallet)',
    account_state: 'State',
    account_state_required_for_wallet: 'State (Required for Wallet)',
    account_phone: 'Phone',
    account_mobile: 'Mobile',
    account_primary_email: 'E-Mail',
    account_pending_email: 'Pending E-Mail address',
    account_address_kyc_status: 'Confirm address details (KYC)',
    account_address_kyc_document: 'Address-kyc Documents',
    account_kyc_not_verified: 'KYC Not Verified',
    wallet_not_yet_created: 'Account has no wallet',
    kyc_bank_documents: 'Bank account KYC documents',
    kyc_tax_documents: 'Tax KYC documents',
    social_security_number: 'Social security Number',
    account_kyc_status: 'Confirm id details (KYC)',
    account_iban: 'IBAN',
    account_bic: 'BIC',
    account_bank_accounts: 'Bank accounts',
    account_bank_account: 'Bank account',
    account_bank_account_headline: 'Bank account list',
    bank_accounts_list: 'List of bank accounts',
    no_bank_accounts: 'No bank accounts',
    is_main_bank_account: 'Main bank account',
    account_bank_historical_data: 'Historical data (without lemonway)',
    account_type: 'Type',
    account_status: 'Status',
    account_holder: 'Bank account holder',
    account_owner: 'Owner',
    account_bank_kyc_status: 'Bank account KYC-status',
    account_profile_overview: 'Profile overview',
    account_profile_details: 'Profile details',
    account_address_contact_details: 'Address and contact details',
    account_address_details: 'Address details',
    account_identity_details: 'Identity details',
    button_delete_dsgvo: 'Delete GDPR data',
    create_natural_account: 'Create natural profile',
    profile_id: 'Profile ID',
    profile_company_name: 'Company name',
    profile_company_company_email: 'Company email',
    profile_company_description: 'Company description',
    profile_company_required_for_wallet: 'Required for wallet',
    profile_company_registration_number: 'Company registration number',
    profile_company_website_url: 'Company website URL',
    profile_company_details_kyc: 'Confirm company details (KYC)',
    profile_company_bank_kyc: 'Confirm bank details (KYC)',
    legal_account_create: 'create legal profile',
    download_signteq_idv_document: 'Download Signteq IDV document',
    legal_account_show: 'Show legal profile',
    contact_person: 'Contact person',
    address_details: 'Address details',
    bank_details: 'Bank details',
    tax_details: 'Tax details',
    depot_data: 'Depot data',
    wallet_details: 'Wallet details',
    kyc_documents: 'KYC documents',
    kyc_id_documents: 'ID check KYC documents',
    kyc_legal_documents: 'Confirm company details (KYC)',
    kyc_document_no_comment: 'No comment for this document',
    open_kyc_document: 'open',
    kyc: 'KYC',
    kyc_external: 'External KYC',
    external_kyc_details: 'External KYC details',
    external_kyc_process_status: 'External KYC status',
    kyc_external_id: 'ID',
    kyc_external_external_id: 'External KYC ID',
    kyc_external_status: 'KYC Status',
    kyc_external_created_at: 'Created on',
    kyc_external_updated_at: 'Last updated on',
    kyc_external_natural_profile_overwritten_at:
        'External KYC natural profile overwritten at',
    kyc_external_result_summary_url: 'Download result summary',
    kyc_external_result_data_package_url: 'Download data package',
    button_kyc_reset_external_process: 'Reset external KYC process',
    comment: 'Comment',
    document_id: 'Document id',
    verification_type: 'Verification type',
    verification_status: 'Verification status',
    account_id: 'Account ID',
    account_document_type: 'Document type',
    valid_to: 'Valid until',
    kyc_verification_status: 'Verification status',
    verification_date: 'Verification date',
    external_kyc: 'External KYC',
    manual_kyc: 'Manual KYC',
    open_doc_in_new_tab: 'Open Doc in new tab',
    kyc_document_file: 'KYC document',
    kyc_type_kyc_id: 'Confirm identity details',
    kyc_type_kyc_bank: 'Confirm bank details',
    kyc_type_kyc_address: 'Confirm address details',
    kyc_type_kyc_tax: 'Confirm tax details',
    kyc_address_documents: 'Address KYC documents',
    tax_number: 'Tax number',
    account_social_security_number: 'Social security number',
    account_tax_kyc_status: 'Tax details KYC-status',
    account_show_legal_account: 'Show legal account',
    profile: 'Profile',
    view_profile: 'View profile',
    wallet_balance: 'Balance',
    wallet_retrievable_balance: 'Retrievable balance',
    wallet_blocked_balance_from_paid_orders: 'Blocked (paid orders)',
    wallet_blocked_balance_from_pending_withdrawals:
        'blocked (pending withdrawals)',
    wallet_status: 'Wallet status',
    wallet_currency: 'currency',
    wallet_deposit_information: 'Deposit information',
    wallet_deposit_account_holder: 'Account holder',
    wallet_deposit_iban: 'IBAN',
    wallet_deposit_bic: 'BIC',
    wallet_deposit_payment_reference: 'Payment reference',
    money_withdrawal_value: 'Withdrawal amount',
    yes: 'yes',
    no: 'no',
    search_account_title: 'Search Account',
    nothing_found: 'Nothing found',
    search_other_user: 'Search other user',
    order_send_mails: 'Send order mails',
    date_of_order: 'Date of order',
    edit_order: 'Edit order',
    additional_fields: 'Additional fields',
    order_attachment_type: 'Order attachment type',
    order_attachment_name: 'Order attachment name',
    order_attachment_description: 'Order attachment description',
    order_attachments: 'Order attachments',
    order_attachment_upload: 'Upload order attachment',
    order_documents: 'Order documents',
    reporting_documents: 'Reporting documents',
    documents: 'Documents',
    view_document: 'View document',
    depot: 'Depot',
    depot_owner: 'Account holder',
    depot_number: 'Account number',
    depot_bank: 'Bank name',
    deposit_account_holder: 'Deposit account holder',
    depot_bic: 'BIC or bank code',
    order_details: 'Order details',
    order_notes: 'Order notes',
    order_id: 'Order id',
    order_emission_signature: 'Emission signature',
    order_emission_signatures: 'Emission signatures',
    document_type: 'Document type',
    signature_date: 'Signature date',
    signature_cancellation_date: 'Signature cancellation date',
    confirm_manual_signature: 'Confirm manual signature',
    regenerate_signatures: 'Regenerate signatures',
    upload_signed_document: 'Upload signed document',
    modal_title_upload_signed_document: 'Upload signed document',
    signed_document: 'Signed document',
    toast_success_signed_document_uploaded: 'Signed document uploaded',
    toast_success_signature_confirmed: 'Signature confirmed',
    signature_pending_review: 'Pending review',
    order_summary: 'Order summary',
    account_name: 'Account name',
    change_order_status: 'Change order status',
    bulk_change_order_status: 'Change order status of multiple orders',
    total: 'Total',
    invested_amount: 'Invested amount',
    wallet_amount: 'Wallet amount',
    total_amount_to_pay: 'Total amount to pay',
    incentive: 'Incentive',
    voucher_amount: 'Voucher amount',
    voucher_balance: 'Voucher balance',
    vouchers: 'Vouchers',
    reference_number: 'Reference',
    order_was_created_manually: 'Created manually',
    profile_information_legal: 'Investor (Legal Profile)',
    profile_legal: 'Legal Profile',
    profile_information_natural: 'Investor (Natural Profile)',
    linked_profile_information_natural: 'Linked natural profile',
    date_of_birth: 'Date of birth',
    nationality: 'Nationality',
    change_status_to: 'Change Status to',
    for_selected_orders: 'for {selected} orders',
    account_name_at_order: 'Account name (at order)',
    account_name_current: 'Account name (current)',
    investor_information_for_germany: 'Investor Information for Germany',
    please_confirm_data: 'Please Confirm Data',
    first_name: 'First name',
    last_name: 'Last name',
    place_of_birth: 'Place of birth',
    id_card_passport_number: 'ID/Passport Number',
    issuing_authority: 'Issuing Authority',
    vib_investment_information:
        'I hereby confirm that I was provided with the investment information sheet (Vermögensanlagen-Informationsblatt) in good time and that I have downloaded and saved it. In particular, I have taken note of the warning that the acquisition of this investment is associated with considerable risks and may lead to the total loss of the capital invested.',
    vib_investment_under_1000:
        'I hereby confirm that the total amount of investment assets I have acquired from „synthesize B2C markets (EM)“ (including the loan amount granted to me under this investment offer) does not exceed EUR 1,000',
    vib_investment_income:
        'I hereby confirm that the total amount of investment assets I have acquired from synthesize B2C markets (EM) (including the loan amount granted to me under this investment offer) is between EUR 10,000 and EUR 25,000, but does not exceed twice my average monthly net income.',
    vib_investment_financial_assets_over_10000:
        'I hereby confirm that the total amount of investment assets I have acquired from „synthesize B2C markets (EM)“ (including the loan amount granted to me under this investment offer) is between EUR 1,000 and EUR 10,000, and that I have freely available assets in the form of bank deposits and financial instruments of at least EUR 100,000.',
    vib_investment_limit:
        'I hereby confirm that I have not acquired more than a total of EUR 25,000 in investment assets from the issuer „synthesize B2C markets (EM)“ (including the loan amount I have chosen under this investment offer).',
    wphg_investment_under_1000:
        'I hereby confirm that my investment does not exceed EUR 1,000.',
    wphg_investment_limit:
        'I hereby confirm that I have not invested more than a total of EUR 25,000 in securities of the issuer synthesize B2C markets (EM) (including the investment I have chosen under this offer).',
    wphg_inappropriate_investment:
        'I am aware that, based on the information I have provided, subscribing to this product does not match my investor profile. I nevertheless choose to subscribe to this product.',
    set_to_canceled: 'Cancel order',
    set_to_paid: 'Set to paid',
    set_to_pending: 'Set to pending',
    set_to_accepted: 'Set to accepted',
    investment: 'Investment',
    bullet: 'Bullet',
    period: 'Period',
    next_payment: 'Next payment',
    interest: 'Interest',
    gross_interest: 'Gross interest',
    payouts: 'Payouts',
    contract_duration: 'Contract duration',
    first_payout: 'First Payout',
    last_payout: 'Last Payout',
    total_payments_count: 'Total Payments Count',
    start_of_contract: 'Start of Contract',
    add_date: 'Add payout date',
    early_bird_promotion: 'Early Bird Promotion',
    early_bird_interest_rate: 'Early Bird Interest Rate',
    early_bird_deadline: 'Early Bird Deadline',
    interest_rate_calculation: 'Interest Rate Calculation',
    calculation_method: 'Calculation Method',
    calculation_start_date: 'Calculation Start Date',
    repayment: 'Repayment',
    bullet_loan: 'Bullet Loan',
    deferred_clearance: 'Deferred Clearance',

    // Contract class details (asset_class-driven contract fields)
    contract_class_details: 'Class-specific Details',
    conversion_trigger_type: 'Conversion Trigger Type',
    conversion_price_formula: 'Conversion Price Formula',
    conversion_price_reference_days: 'Conversion Price Reference Days',
    conversion_price_floor: 'Conversion Price Floor',
    conversion_price_discount_pct: 'Conversion Price Discount (%)',
    conversion_price_final: 'Final Conversion Price',
    conversion_date_annual: 'Annual Conversion Date',
    conversion_window_open_days: 'Conversion Window Open Days',
    conversion_conditions: 'Conversion Conditions',
    conversion_valuation: 'Conversion Valuation',
    disagio_pct: 'Disagio (%)',
    early_repayment_price_threshold_pct: 'Early Repayment Price Threshold (%)',
    early_repayment_observation_days: 'Early Repayment Observation Days',
    collateral_description: 'Collateral Description',
    gs_participation_rate_max: 'Max. Profit Participation Rate',
    share_capital_base: 'Share Capital Base',
    min_interest_rate_pa: 'Minimum Interest Rate p.a.',
    ebit_multiple: 'EBIT Multiple',
    revenue_multiple: 'Revenue Multiple',
    settlement_costs_pct: 'Settlement Costs (%)',
    participation_share_per_gs: 'Participation Share per Certificate',
    cancellation_possible_from: 'Cancellation Possible From',
    termination_notice_months: 'Termination Notice (Months)',
    termination_reference_date: 'Termination Reference Date',
    repayment_type: 'Repayment Type',
    repayment_schedule: 'Repayment Schedule',
    help_repayment_schedule:
        'Only used when repayment type is irregular. The amounts must add up to exactly 100%.',
    help_repayment_schedule_empty: 'No repayment schedule entries yet.',
    repayment_schedule_total: 'Total: {total}%',
    amount_pct: 'Amount (%)',
    accrued_interest_applicable: 'Accrued Interest Applicable',
    default_interest_rate: 'Default Interest Rate',
    early_repayment_min_yield_pct: 'Early Repayment Minimum Yield (%)',
    in_kind_interest_rate: 'In-Kind Interest Rate',

    // ConversionTriggerType
    IPO: 'IPO',
    ANNUAL: 'Annual',
    PRICE_THRESHOLD: 'Price Threshold',
    MATURITY: 'Maturity',

    // ConversionPriceFormula
    VWAP: 'VWAP',
    // FIXED: 'Fixed', (already defined above under ContractPeriodType, same value)
    IPO_PRICE: 'IPO Price',

    // RepaymentType
    BULLET: 'Bullet',
    REGULAR: 'Regular',
    IRREGULAR: 'Irregular',

    external_wallet: 'External Wallet',
    external_wallet_id: 'External Wallet ID',
    wallet_id: 'Wallet ID',
    voucherify_settings: 'Voucherify Settings',
    voucher_wallet: 'Voucher Wallet',
    voucher_campaign: 'Voucher Campaign',
    voucher_campaigns: 'Voucher Campaigns',
    voucher_campaign_name: 'Campaign name',
    add_voucher_campaign: 'Add campaign',
    voucher_campaign_type: 'Campaign type',
    voucher_campaign_default: 'Default',
    voucher_contract: 'Voucher Contract',
    interest_payments: 'Interest Payments',
    paid_interest: 'Paid interest',
    paid_clearance: 'Paid clearance',
    payment: 'Payment',
    total_amount: 'Total amount',
    sum_paid_clearance: 'Sum paid clearance',
    sum_paid_interest_net: 'Sum paid interest net',
    bonus: 'bonus',
    download_sepa_csv: 'Download SEPA CSV',
    start_payment: 'Start payment',
    paid_at: 'Paid at',
    accepted_at: 'Accepted at',
    interest_payment_transactions: 'Interest payment transactions',
    loan: 'Loan',
    clearance: 'clearance',
    rest: 'rest',
    execute_interest_payment: 'Execute interest payment',
    execute_interest_payment_including_sepa_export:
        'Execute interest payment including SEPA export',
    recalculate: 'Recalculate',
    recalculate_and_export_excel: 'Recalculate and export excel',
    recalculate_and_export_sepa_csv: 'Recalculate and export SEPA CSV',
    please_recalculate_interest_first: 'Please recalculate interest first',
    sum_paid_rest: 'Sum paid rest',
    pay_interest: 'Pay interest',
    pay_clearance: 'Pay clearance',
    pay_percent_of_rest: 'Pay percent of rest',
    interest_bonus: 'Interest bonus',
    new_calculation: 'New calculation',
    load_payout_tasks: 'Lad payout tasks',
    start_interest_payment_payout: 'Start interest payment payout',
    started_at: 'Started at',
    finished_at: 'Finished at',
    finished_type: 'Finished_type',
    result: 'Result',
    result_details: 'Result details',
    interest_payment_date: 'Interest payment date',
    settings: 'Settings',
    sign_out: 'Sign out',
    export_accounts_csv: 'Export filtered Accounts-List',
    export_kyc_folder: 'Export KYC Folder (ECSP)',
    view: 'View',
    no_table_entries: 'There are no entries.',
    check_table_filters: 'Change filter settings.',
    export_orders_csv: 'Export filtered Orders-List',
    bulk_change_order_campaign: 'Change campaign',
    active: 'Active',
    natural_account: 'Natural account',
    legal_account: 'Legal account',
    no_orders: 'There is no orders.',
    manual_investments: 'Manual investments',
    duplicate: 'Duplicate',
    change_status: 'Change status',
    emails: 'Emails',
    email_template: 'Email Template',
    recipient: 'Recipient',
    change_order_status_date: 'Change status date',
    is_test: 'Test',
    send: 'Send',

    button_bank_kyc_document_upload: 'Upload bank verification document',
    button_address_kyc_document_upload: 'Upload address verification document',
    button_tax_kyc_document_upload: 'Upload tax verification document',
    button_id_kyc_document_upload: 'Upload ID verification document',
    button_legal_kyc_document_upload: 'Upload company verification document',
    button_sync_wallet: 'Sync wallet',
    button_delete_legal: 'Delete account',
    sender: 'Sender',
    receiver: 'Receiver',
    transaction_method: 'Transaction method',
    date_from: 'Date from',
    date_to: 'Date to',
    view_linked_order: 'View linked order',
    view_sender_natural_profile: 'View natural profile of sender',
    view_receiver_natural_profile: 'View natural profile of receiver',
    view_sender_legal_profile: 'View legal profile of sender',
    view_receiver_legal_profile: 'View legal profile of receiver',
    no_signatures: 'There are no signatures.',
    billing_address: 'Billing address',
    postal_address: 'Postal address',
    contact_details: 'Contact details',
    same_as_billing_address: 'Same as billing address',

    help_platform_name: 'The name of the platform.',
    help_parent_platform_name: 'Select the parent platform.',
    help_platform_url: 'The URL of the platform.',
    help_file_name: 'The name of the file.',
    help_file_type: 'The type of file.',
    help_platform_webhook_event: 'The event to trigger the action.',
    help_platform_webhook_url:
        'The URL to be triggered when the action event occurs.',
    help_platform_webhook_secret:
        'The secret to secure the webhook url. You can only retrieve the secret during creation!',
    help_platform_policy_name: 'The name of the platform policy.',
    help_platform_policy_country: 'The country this policy is valid for.',
    help_platform_policy_language: 'The language of the policies content.',
    help_platform_policy_content: 'The content of the policy.',
    help_cookie_consent_service_category:
        'The consent category this service belongs to.',
    help_cookie_consent_service_provider_key:
        'The provider/vendor this service represents.',
    help_cookie_consent_service_name:
        'The name of the service shown to visitors in the cookie banner.',
    help_cookie_consent_service_description:
        'The description of the service shown to visitors in the cookie banner.',
    help_cookie_consent_service_enabled:
        'Whether this service is active and shown in the cookie banner.',
    help_platform_email_template_type: 'The type of the email template.',
    help_platform_email_template_language:
        'The language of the email templates content.',
    help_platform_email_template_number_locale:
        'Override the number formatting locale for this email template. Leave empty to derive from the campaign language.',
    help_platform_email_template_subject: 'The subject of the email template.',
    help_platform_email_template_content:
        'The content of the email template. To reload the placeholders, clear the type and select the appropriate one.',
    help_platform_disclaimer_name: 'The name of the disclaimer.',
    help_platform_disclaimer_language:
        'The language of the disclaimers content.',
    help_platform_disclaimers_countries_applied:
        'The countries, this disclaimer is applied in.',
    help_platform_disclaimers_countries_not_applied:
        'The countries, this disclaimer is NOT applied in.',
    help_platform_disclaimer_content: 'The content of the platform disclaimer.',
    help_platform_terms:
        'Publicly accessible URL to the terms of service of the platform.',
    help_platform_privacy_url:
        'Publicly accessible URL to the privacy policy of the platform.',
    help_platform_admin_email:
        'Email address used by the platform to send emails.',
    help_platform_mail_template:
        'Email template used for outgoing emails sent by the platform.',
    help_clearing_systems: 'Select one or more clearing systems.',
    help_clearing_system: 'Select a clearing systems.',
    help_order_status_for_total_funding_sum:
        'Select one or more order status that will be considered when calculating the total funding sum.',
    help_mail_host: 'The SMTP server to use when sending emails.',
    help_mail_port:
        'The server port to use when communicating with the SMTP server.',
    help_mail_encryption:
        'The encryption method to use when communicating with the SMTP server.',
    help_mail_from_address: 'The sending email address of outgoing emails.',
    help_mail_form_name: 'The name of the sender of outgoing emails.',
    help_mail_username: 'The username to authenticate to the SMTP server.',
    help_mail_password: 'The password to authenticate to the SMTP server.',
    help_asset_title: 'The title of the asset.',
    help_currency: 'The currency to use.',
    help_asset_base_funding_count:
        'Manually increase the number of investments.',
    help_asset_base_funding_total: 'Manually increase the investment amount.',
    help_asset_category: 'The asset category.',
    help_asset_currency: 'The currency to use on this asset.',
    help_asset_deactivate_payment_account:
        'Should automatic payments be deactivated?',
    help_asset_funding_min: 'The funding minimum.',
    help_asset_funding_max: 'The funding maximum.',
    help_asset_investment_min: 'The minimal amount per investment.',
    help_asset_investment_max: 'The maximal amount per investment.',
    help_asset_manual_funding_totals: 'Use manual investment totals?',
    help_asset_location_city: 'The asset location city.',
    help_asset_location_state: 'The asset location state',
    help_asset_location_country: 'The asset location country.',
    help_asset_status: 'Main status.',
    help_asset_step_level: 'The step levels to follow for investments.',
    help_asset_quick_amounts:
        'Enter 4 values, one per line. These will be shown as quick-select amounts on the investment page.',
    help_asset_sub_status: 'Sub status.',
    help_company_name: 'The company name.',
    help_company_logo: 'The company logo to display in the frontend.',
    help_company_address: 'The address of the company.',
    help_company_city: 'The city of the company address.',
    help_company_postal_code: 'The postal code of the company address.',
    help_company_state: 'The state of the company address.',
    help_company_country: 'The country of the company address.',
    help_company_email: 'The email of the company.',
    help_company_phone_number: 'The phone number of the company.',
    help_company_website: 'The website of the company.',
    bank_account_holder: 'Bank account holder',
    help_company_bank_account_holder: 'The bank account holder of the company.',
    help_company_iban: 'The IBAN of the company.',
    help_company_bic: 'The BIC of the company.',
    help_contract_range:
        'Eg. 3 years, 6 month, "unlimited", ... Shown on the campaign card as the second box (term). Empty = box is hidden.',
    help_interest_rate: 'The interest rate of the contract',
    help_asset_interest_rate:
        'Interest rate in %. Shown on the campaign card as the first box, for bond, convertible bond and subordinated loan. Empty or 0 = box is hidden.',
    help_target_yield:
        'Target yield as free text, e.g. "6-8 % p.a.". Shown on the campaign card as the first box, for participation certificate, profit participation and indirect participation. Empty = box is hidden.',
    help_asset_signature_types: 'The allowed signatures types for the asset.',
    help_signature_manual_confirmation_required:
        'If enabled (default), an order on this asset can only be accepted once its manual signature has been confirmed as signed. If disabled, orders can be accepted without a signed signature; the signature itself still shows as not signed.',
    help_asset_signature_legal_notice: 'The legal notice about the signature.',
    help_asset_document_type: 'The type of the asset document.',
    help_asset_document_description: 'Description of the document',
    help_asset_documents_table_0:
        'These asset documents are sent via mail to the investor.',
    help_asset_documents_table_1:
        'The reporting documents are shown in the frontend.',
    help_asset_documents_table_2:
        'These documents are sent via email to the investor before the investment is completed.',
    help_run_inclusive_acceptance_wallet:
        'The wallet to transfer the funds to.',
    help_run_inclusive_acceptance_date:
        'Investments until this date will be transferred.',
    help_campaign_title: 'The title of the campaign',
    help_campaign_subtitle: 'The subtitle of the campaign',
    help_campaign_slug:
        'Used in the campaign URL. Follows the title automatically when the title changes, unless you change it here. Only lowercase letters, numbers and hyphens, and it must be unique. Links with the previous slug stop working.',
    help_country_campaign:
        'Select the country this campaign will be published.',
    help_language_campaign: 'Select the language of the campaign.',
    number_locale: 'Number Locale',
    help_number_locale_campaign:
        'Override the number formatting locale for emails. Leave empty to derive from the campaign language.',
    help_campaign_summary: 'The summary of the campaign.',
    help_platform_name_campaign:
        'Select the platform this asset is associated with.',
    help_asset_title_campaign:
        'Select the asset this campaign is associated with.',
    help_campaign_excerpt: 'The excerpt of the campaign',
    help_funding_start: 'Start of the Funding of the Campaign',
    help_funding_end: 'End of the Funding of the Campaign',
    help_waitlist_url: 'URL of the waitlist signup page for this campaign.',
    help_waitlist_text:
        'Text shown alongside the waitlist signup link for this campaign.',
    help_regulatory_requirements:
        'The regulatory requirements for this campaign.',
    help_asset_regulation_override:
        "Overrides the asset's own regulation value for display purposes on this campaign only.",
    help_is_co_placement: 'Marks this campaign as a co-placement.',
    help_agio_disagio: 'Agio/Disagio',
    help_agio_disagio_title: 'The Agio/Disagio title.',
    help_agio_disagio_rate: 'The Agio/Disagio rate.',
    help_agio_disagio_type: 'The Agio/Disagio type.',
    help_agio_disagio_info_text: 'The Agio/Disagio Infotext.',
    help_agio_disagio_disclaimer: 'The Agio/Disagio disclaimer.',
    help_agio_disagio_voucher: 'Enable or disable a voucher for agio/disagio.',
    help_voucher_code: 'The voucher code for the agio/disagio voucher.',
    help_voucher_rate: 'The discount provided by the voucher.',
    help_status_campaign: 'Campaign status.',
    help_funding_stats_visible:
        'Toggle to see the funding stats in the frontend.',
    help_password_campaign:
        'Password to secure the campaign. Only users with access can invest.',
    error_private_placement_password_required:
        'A private placement needs a password.',
    help_broker_status: 'Should the following disclaimer be shown?',
    help_broker_field_required:
        'Should the broker field be shown as a required field in the order process?',
    help_broker_disclaimer: 'The disclaimer to be shown in the frontend.',
    help_external_project_url: 'Link to an external project page.',
    help_campaign_badge: 'Select the badge to show on the campaign header.',
    help_show_amount_slider:
        'Should the amount slider be shown during the first step of the investment process.',
    help_campaign_thumb_image: 'The campaign thumbnail',
    help_campaign_hero_image: 'The campaign main image',
    help_main_campaign: 'Campaign main content',
    help_summary_campaign: 'Campaign summary',
    help_associate_orders_modal_text:
        'Do you want to associate all orders that do not belong to a contract with the contract {contract}?',
    help_drag_and_drop: 'Drag and drop items to change the order.',
    help_campaign_content_block_title: 'Title of the content block.',
    help_campaign_content_block_content: 'Content of the content block.',
    help_campaign_incentive_amount: 'The incentive amount.',
    help_campaign_incentive_description: 'The incentive description.',
    help_campaign_incentive_title: 'The incentive title.',
    help_campaign_team_member_name: 'The team member name.',
    help_campaign_team_member_title: 'Title of the team member.',
    help_campaign_team_member_bio: 'The team member bio.',
    help_campaign_team_member_image: 'Picture of the team member.',
    help_order_invested_amount: 'The Invested Amount.',
    help_order_notes: 'Add notes to the order',
    help_order_send_mails: 'Send order mails.',
    help_date_of_order: 'The date of order.',
    help_select_campaign: 'Select the campaign.',
    help_select_incentive: 'Select the incentive.',
    help_contract_type: 'The contract type.',
    help_search_account_title: 'Search for the Account.',
    help_search_field: 'Type at least 3 characters into the search field.',
    help_order_attachment_type: 'Select the order attachment type.',
    help_order_attachment_name: ' The order attachment name.',
    help_order_attachment_description: 'The order attachment description.',
    help_additional_fields_enabled:
        'Activate or deactivate the additional fields (All fields are always activated or deactivated). The following switches are for the mandatory entry of the respective fields.',
    help_depot_owner: 'The depot owner.',
    help_depot_number: 'The depot number.',
    help_depot_bank: 'The depot bank.',
    help_deposit_account_holder: 'The deposit account holder.',
    help_depot_bic: 'The Depot BIC.',
    help_email: 'The email address.',
    help_city: 'The city.',
    help_date: 'The date.',
    help_first_name: 'The first name.',
    help_last_name: 'The last name.',
    help_place_of_birth: 'The place of birth.',
    help_date_of_birth: 'The date of Birth.',
    help_id_card_passport_number: 'The ID or Passport Number.',
    help_issuing_authority: 'The Issuing Authority.',
    help_address: 'The address.',
    help_postal_code: 'The postal code.',
    help_state: 'The region.',
    help_tax_number: 'The tax number.',
    help_bulk_change_order_status: 'Select the new status.',
    help_contract_duration:
        'Select the option for the duration of the contract.',
    help_first_payout: 'First payout date.',
    help_last_payout: 'Last payout date.',
    help_total_payments_count: 'The number of payouts for the contract.',
    help_start_of_contract: 'Select the start period for the payments.',
    help_early_bird_promotion:
        'Enable or disable the Early Bird Promotion for this contract.',
    help_early_bird_interest_rate:
        'Early Bird Interest rate for the Promotion.',
    help_early_bird_deadline: 'Set the deadline for the early bird promotion.',
    help_calculation_method:
        'Select the calculation method for the interest rate.',
    help_calculation_start_date:
        'Select the date that should be used for the start of the interest rate calculation.',
    help_bullet_loan:
        'Enable or disable repayments at the end of the contract duration.',
    help_deferred_clearance:
        'Number or payments that the repayment is deffered.',
    tax_calculation: 'Tax Calculation (Church Tax)',
    tax_calculation_enabled: 'Enable Tax Calculation',
    help_external_wallet_id: 'Set the external wallet ID for this contract.',
    help_voucher_wallet:
        'The redeemed vouchers are debited from this Lemonway wallet.',
    help_voucher_campaign_name: 'The voucher campaign name.',
    help_voucher_campaign_type: 'The voucher campaign type.',
    help_voucher_campaign_default: 'Set the voucher campaign as default.',
    help_pay_percent_of_rest: 'The payment percent of rest.',
    help_interest_bonus: 'The interest bonus.',
    help_open_file_in_new_tab: 'open file in new tab',
    help_show_verification_comment: 'show comment',
    help_account_first_name: 'First name',
    help_account_last_name: 'Last name',
    help_account_email: 'Email address',
    help_account_nationality: 'Nationality',
    help_account_gender: 'The gender',
    help_account_country: 'The country',
    help_account_address: 'The address',
    help_account_zip: 'The ZIP code',
    help_account_city: 'The city',
    help_account_state: 'The state',
    help_account_phone: 'The phone number',
    help_account_mobile: 'The mobile phone number',
    help_account_tax_number: 'The tax number',
    help_account_social_security_number: 'The social security number',
    help_account_email_pending: 'E-Mail verification',
    help_account_company_description: 'Company description',
    help_account_company_registration_number: 'Company registration number',
    help_account_company_name: 'Company name',
    help_account_name: 'The investor name.',
    help_account_custom_id: 'Individual ID',
    help_campaigns_table: 'The Campaigns table.',
    help_contracts_table: 'The Contracts table.',
    help_bank_account: 'Verified bank account',
    help_money_withdrawal_comment: 'Comment for the withdrawal',
    help_money_withdrawal_amount: 'Amount of the withdrawal',
    help_kyc_document_type: 'Document type',
    help_kyc_document_iban: 'IBAN',
    help_kyc_document_account_holder: 'Bank account holder',
    help_bank_account_holder: 'Bank account holder',
    help_bank_account_iban: 'IBAN',
    help_bank_account_bic: 'BIC',
    error_invalid_iban: 'This IBAN is not valid.',
    error_invalid_bic: 'This BIC is not valid.',
    modal_title_create_bank_account: 'Create bank account',
    modal_title_update_bank_account: 'Update bank account',
    modal_title_delete_bank_account: 'Delete bank account',
    modal_confirm_delete_bank_account:
        'Are you sure you want to delete this bank account?',
    toast_success_bank_account_created: 'Bank account created!',
    toast_error_bank_account_create: 'Creating the bank account failed!',
    toast_success_bank_account_updated: 'Bank account updated!',
    toast_error_bank_account_update: 'Updating the bank account failed!',
    toast_success_bank_account_deleted: 'Bank account deleted!',
    toast_error_bank_account_delete: 'Deleting the bank account failed!',
    set_as_primary: 'Set as primary',
    help_set_as_primary: 'Set as primary for the platform',
    primary_for_platforms: 'Primary for',
    help_view_bank_account_audits: 'View change history',
    help_edit_order: 'Edit order',
    help_campaign_content_images_table: 'The Campaign Content Images table.',
    help_campaign_content_documents_table:
        'The Campaign Content Documents table.',
    help_campaign_content_blocks_table: 'The Campaign Content Blocks table.',
    help_platform_attachments_table: 'The Platform Attachments table.',
    help_platform_documents_table:
        'Documents uploaded once for this platform (e.g. general terms, disclosures) that can be linked to any asset.',
    help_linked_platform_documents:
        'Platform documents shown to investors during the investment process for this asset, alongside its own contract data documents.',
    help_platform_webhooks_table: 'The Platform Webhooks table.',
    help_platform_policies_table: ' The Platform Policies table',
    help_platform_cookie_consent_services_table:
        'The Cookie Consent Services table.',
    help_platform_email_templates_table: 'The Platform Email Templates table.',
    help_platform_disclaimers_table: 'The Platform Disclaimers table',
    help_bulk_change_order_campaign: 'Select the new campaign.',
    help_assets_table: 'The Assets table.',
    help_asset_contracts_table: 'The Asset Contracts table.',
    help_platforms_table: 'The platforms.',
    help_orders_table: 'The orders.',
    help_valid_to: 'Valid date must be after the day after tomorrow',
    help_verification_status: 'Verification status',
    help_comment: 'Comment',
    help_investor_modal: 'The investor to execute the action as.',
    help_incentives_table: 'The incentives.',
    help_bank_accounts_table: 'The bank accounts.',
    help_view_order: 'View order',
    help_wallet_transaction_table: 'The wallet transactions table',
    help_withdrawals_table: 'The withdrawals table',
    help_natural_profiles: 'Linked natural profiles',
    help_view_natural_profile: 'View linked natural profile',
    help_accounts_table: 'Accounts',
    help_order_attachments_table: 'Order attachments',
    help_manual_investments:
        'Change manually the count and total_amount of investments.',
    help_emails_table: 'Emails',
    help_team_members_table: 'The team members table.',
    help_order_status: 'Please select the status date you want to change.',
    help_order_status_date:
        'Please select the date you want to change the status date to.',
    help_transactions_table: 'Transactions',
    help_default_language: 'Default language',
    help_account_country_of_birth: 'Country of birth',
    help_account_city_of_birth: 'City of birth',
    help_savings_plan: 'Activate savings plan Email',
    help_savings_plan_description:
        'This text will appear in investment process summary',

    modal_title_export_result: 'Export',
    modal_title_delete_platform: 'Delete platform?',
    modal_title_delete_platforms: 'Delete platforms?',
    modal_title_update_platform_attachment: 'Update platform attachment',
    modal_title_create_platform_attachment: 'Create platform attachment',
    modal_title_delete_platform_attachment: 'Delete platform attachment?',
    modal_title_delete_platform_attachments: 'Delete platform attachments?',
    modal_title_update_platform_document: 'Update platform document',
    modal_title_create_platform_document: 'Create platform document',
    modal_title_delete_platform_document: 'Delete platform document?',
    modal_title_delete_platform_documents: 'Delete platform documents?',
    modal_title_edit_linked_platform_documents: 'Linked platform documents',
    modal_title_update_platform_webhook: 'Update platform webhook',
    modal_title_create_platform_webhook: 'Create platform webhook',
    modal_title_delete_platform_webhook: 'Delete platform webhook?',
    modal_title_delete_platform_webhooks: 'Delete platform webhoooks?',
    modal_title_update_platform_policy: 'Update platform policy',
    modal_title_create_platform_policy: 'Create platform policy',
    modal_title_delete_platform_policy: 'Delete platform policy?',
    modal_title_delete_platform_policies: 'Delete platform policies?',
    modal_title_update_platform_cookie_consent_service:
        'Update cookie consent service',
    modal_title_create_platform_cookie_consent_service:
        'Create cookie consent service',
    modal_title_delete_platform_cookie_consent_service:
        'Delete cookie consent service?',
    modal_title_delete_platform_cookie_consent_services:
        'Delete cookie consent services?',
    modal_title_update_platform_email_template:
        'Update platform email template',
    modal_title_create_platform_email_template:
        'Create platform email template',
    modal_title_view_platform_email_template: 'View platform email template',
    modal_title_delete_platform_email_template:
        'Delete platform email template?',
    modal_title_delete_platform_email_templates:
        'Delete platform email templates?',
    modal_title_update_platform_disclaimer: 'Update platform disclaimer',
    modal_title_create_platform_disclaimer: 'Create platform disclaimer',
    modal_title_delete_platform_disclaimer: 'Delete platform disclaimer?',
    modal_title_delete_platform_disclaimers: 'Delete platform disclaimers?',
    modal_title_delete_asset: 'Delete Asset?',
    modal_title_delete_assets: 'Delete Assets?',
    modal_title_update_asset_document: 'Update asset document',
    modal_title_create_asset_document: 'Create asset document',
    modal_title_update_ecsp_document: 'Edit ECSP Document',
    modal_title_view_ecsp_document: 'View ECSP Document',
    modal_title_update_asset_document_0:
        'Update asset document (contract detail)',
    modal_title_create_asset_document_0:
        'Create asset document (contract detail)',
    modal_title_update_asset_document_1: 'Update asset document (reporting)',
    modal_title_create_asset_document_1: 'Create asset document (reporting)',
    modal_title_update_asset_document_2:
        'Update asset document (consumer information)',
    modal_title_create_asset_document_2:
        'Create asset document (consumer information)',
    modal_title_delete_asset_document: 'Delete asset document?',
    modal_title_delete_asset_documents: 'Delete asset documents?',
    modal_title_run_inclusive_acceptance: 'Run inclusive acceptance',
    modal_title_run_exclusive_acceptance: 'Run exclusive acceptance process',
    modal_title_delete_campaign: 'Delete campaign?',
    modal_title_delete_campaigns: 'Delete campaigns?',
    modal_title_associate_orders: 'Associate orders?',
    modal_title_delete_asset_contract: 'Delete asset contract?',
    modal_title_delete_asset_contracts: 'Delete asset contracts?',
    modal_title_delete_campaign_content_image: 'Delete content image?',
    modal_title_delete_campaign_content_images: 'Delete content images?',
    modal_title_delete_campaign_content_document: 'Delete content document?',
    modal_title_delete_campaign_content_documents: 'Delete content documents?',
    modal_title_delete_campaign_content_block: 'Delete content block?',
    modal_title_delete_campaign_content_blocks: 'Delete content blocks?',
    modal_title_view_campaign_content_block: 'View content block',
    modal_title_edit_campaign_content_block: 'Edit content block',
    modal_title_create_campaign_content_block: 'Create content block',
    modal_title_view_campaign_team_member: 'View team member',
    modal_title_create_campaign_team_member: 'Create team member',
    modal_title_edit_campaign_team_member: 'Edit team member',
    modal_title_delete_campaign_team_member: 'Delete team member?',
    modal_title_delete_campaign_team_members: 'Delete team members?',
    modal_title_view_campaign_incentive: 'View incentive',
    modal_title_edit_campaign_incentive: 'Edit incentive',
    modal_title_create_campaign_incentive: 'Create incentive',
    modal_title_delete_campaign_incentive: 'Delete incentive?',
    modal_title_delete_campaign_incentives: 'Delete incentives?',
    modal_title_create_order: 'Create order',
    modal_title_edit_order_attachment: 'Edit order attachment',
    modal_title_create_order_attachment: 'Create order attachment',
    modal_title_delete_order_attachment: 'Delete order attachment?',
    modal_title_delete_order_attachments: 'Delete order attachments?',
    modal_title_confirm_signature: 'Confirm signature',
    modal_title_cancel_order: 'Cancel Order?',
    modal_title_confirm_refund_accepted_order:
        'Confirm Refund of Accepted Order',
    modal_text_confirm_refund_accepted_order:
        'This investment has been accepted and may have outstanding obligations. Please confirm you want to proceed with the refund.',
    with_refund: 'Refund payment',
    help_with_refund:
        'Trigger a payment refund via Secupay when cancelling this order.',
    cancel_order_within_cancel_period_warning:
        'Warning: This investment is still within the investor cancel period (expires {deadline}). The investor may still be expecting to cancel it themselves.',
    cancel_order_policy_conflict_confirm:
        'I understand that this cancellation overrides the active investor cancel policy and confirm I want to proceed.',
    confirm_refund_on_accepted_orders: 'Confirm refund for accepted orders',
    help_confirm_refund_on_accepted_orders:
        'Also refund orders that have already been accepted. Use with caution — accepted orders may have outstanding obligations.',
    modal_title_accept_order: 'Accept this Order?',
    modal_title_set_order_status_to_pending: 'Set order status to pending?',
    modal_title_set_order_status_to_paid: 'Set Order Status to PAID?',
    modal_title_delete_contract: 'Delete contract?',
    modal_title_delete_contract_template: 'Delete contract document?',
    modal_delete_warning_contract_template:
        'Are you sure you want to delete the contract document?',
    modal_title_delete_contracts: 'Delete contracts?',
    modal_title_delete_task: 'Delete task?',
    modal_title_confirm_update_contract: 'Confirm update contract',
    modal_title_new_interest_payment_calculation:
        'New interest payment calculation',
    modal_title_execute_interest_payment: 'Execute interest payment?',
    modal_title_payout_task: 'Payout task',
    modal_title_start_interest_payment_payout: 'Start interest payment payout?',
    modal_title_create_money_withdrawal: 'Create money withdrawal',
    modal_title_show_kyc_document_comment: 'Document comments',
    modal_title_create_bank_kyc_document:
        'Upload KYC document for bank account',
    modal_title_create_address_kyc_document:
        'Upload KYC document for address verification',
    modal_title_create_tax_kyc_document:
        'Upload KYC document for tax verification',
    modal_title_create_legal_kyc_document:
        'Upload KYC document for company details confirmation',
    modal_title_bulk_change_order_status: 'Bulk change order status',
    modal_title_bulk_change_order_campaign: 'Bulk change order campaign',
    modal_title_delete_natural_profile: 'Delete GDPR data?',
    modal_title_delete_legal_profile: 'Delete account?',
    modal_title_update_kyc_document: 'Update KYC Document',
    modal_title_create_id_kyc_document:
        'Upload KYC Document for ID verification',
    modal_title_create_nautral_account: 'Create natural profile',
    modal_title_change_campaign_status: 'Change campaing status',
    modal_title_change_order_status_date: 'Change order status date',

    modal_text_confirm_signature:
        'Are you sure you want to manually confirm the signature? This should only be done after a legally binding document has been received and reviewed.',
    modal_text_regenerate_signature:
        'Are you sure you want to regenerate the signatures? All currently active signatures will get cancelled.',
    modal_text_order_status_set_order_status_paid:
        'YES, set Order Status to PAID.',
    modal_text_order_status_accept: 'YES, ACCEPT this order.',
    modal_text_order_status_set_order_status_pending:
        'YES, set Order Status to PENDING.',
    modal_text_order_status_set_order_status_canceled:
        'YES, set Order Status to CANCELED.',
    modal_text_confirm_update_contract:
        'The contract with id {contract} has orders. Do you want to updated this contract?',
    modal_text_execute_interest_payment:
        'Are you sure to execute this Interest Payment? This cannot be undone.',
    modal_text_start_interest_payment_payout:
        'Are you sure that the interest payment payouts should be made to the wallets?',
    modal_text_delete_natural_profile:
        'Are you sure you want to delete all information about this account. This GDPR deletion deletes account, kyc documents, audits, ... of this account. This also deletes all other accounts with the same email address in the same platform. (old versions of this account)',
    modal_text_delete_legal_profile: 'Please confirm the deletion of account.',
    modal_text_delete_task:
        'Do you realy want to delete the task "{type}" which was created on {created}?',
    // eslint-disable-next-line quotes
    toast_error_cannot_delete_platform: "Can't delete this platform!",
    toast_error_access_denied: 'You are not allowed to open page: {path}.',
    toast_success_platform_deleted: 'Platform "{platform}" deleted.',
    toast_success_platforms_deleted: 'Platforms "{platforms}" deleted.',
    toast_success_applying_filters: 'Applying filters: {filters}',
    toast_success_clear_filters: 'Clear filters ...',
    toast_success_platform_created: 'Platform created!',
    toast_success_platform_saved: 'Platform "{platform}" saved!',
    toast_success_platform_attachment_created:
        'Platform attachment "{attachment}" created!',
    toast_success_platform_attachment_updated:
        'Platform attachment "{attachment}" updated!',
    toast_success_platform_attachment_deleted:
        'Platform attachment "{attachment}" deleted!',
    toast_success_platform_attachments_deleted:
        'Platform attachments "{attachments}" deleted!',
    platform_terms_documents: 'Terms Page Documents',
    platform_terms_document: 'Terms page document',
    platform_terms_document_group: 'Group',
    platform_terms_document_languages: 'PDF languages',
    help_platform_terms_document_group:
        'Section of the terms page the document is shown in. New groups are added in the Terms Page Groups table.',
    modal_title_create_platform_terms_document_group: 'Add terms page group',
    modal_title_delete_platform_terms_document_group: 'Delete terms page group',
    toast_success_platform_terms_document_group_created:
        'Terms page group {group} was created.',
    toast_success_platform_terms_document_group_deleted:
        'Terms page group {group} was deleted.',
    platform_terms_document_group_page: 'Page',
    platform_terms_document_group_page_terms: 'Terms',
    platform_terms_document_group_page_data_privacy: 'Data privacy',
    platform_terms_document_groups: 'Terms Page Groups',
    platform_terms_document_group_title_de: 'Heading DE',
    platform_terms_document_group_title_en: 'Heading EN',
    platform_terms_document_group_title_it: 'Heading IT',
    help_platform_terms_document_group_titles:
        'Heading of the group on the terms page per language. The German heading is required; empty languages show the German one.',
    modal_title_update_platform_terms_document_group: 'Edit terms page group',
    toast_success_platform_terms_document_group_updated:
        'Terms page group {group} was saved.',
    platform_terms_documents_count: 'Documents',
    help_platform_terms_documents_table:
        'Documents of the terms page. Drag and drop sets the order within a group; the group is picked in the document.',
    help_platform_terms_document_groups_table:
        'Sections of the terms page, in display order. Drag and drop to reorder. A group can only be deleted once it has no documents. The data privacy group is built in and shown on the privacy page instead of the terms page.',
    help_platform_terms_document_name:
        'Title the document is shown with on the terms page in the selected language.',
    help_platform_terms_document_language:
        'Language of the PDF you upload or edit. Upload the languages one by one; ✓ marks languages that have a PDF. The terms page only lists the document in the languages it has a PDF for.',
    modal_title_create_platform_terms_document: 'Add terms page document',
    modal_title_update_platform_terms_document: 'Edit terms page document',
    modal_title_delete_platform_terms_documents: 'Delete terms page documents',
    toast_success_platform_terms_document_created:
        'Terms page document {document} was created.',
    toast_success_platform_terms_document_updated:
        'Terms page document {document} was updated.',
    toast_success_platform_terms_documents_deleted:
        'Terms page documents {documents} were deleted.',
    toast_success_platform_document_created:
        'Platform document "{document}" created!',
    toast_success_platform_document_updated:
        'Platform document "{document}" updated!',
    toast_success_platform_document_deleted:
        'Platform document "{document}" deleted!',
    toast_success_platform_documents_deleted:
        'Platform documents "{documents}" deleted!',
    toast_success_asset_linked_platform_documents_updated:
        'Linked platform documents updated!',
    toast_success_platform_webhook_created:
        'Platform webhook "{action}" created!',
    toast_success_platform_webhook_updated:
        'Platform webhook "{action}" updated!',
    toast_success_platform_webhook_deleted:
        'Platform webhook "{action}" deleted!',
    toast_success_platform_webhooks_deleted:
        'Platform webhooks "{actions}" deleted!',
    toast_success_platform_policy_created:
        'Platform policy "{policy}" created!',
    toast_success_platform_policy_updated:
        'Platform policy "{policy}" updated!',
    toast_success_platform_policy_deleted:
        'Platform policy "{policy}" deleted!',
    toast_success_platform_policies_deleted:
        'Platform policies "{policies}" deleted!',
    toast_success_cookie_consent_service_created:
        'Cookie consent service "{service}" created!',
    toast_success_cookie_consent_service_updated:
        'Cookie consent service "{service}" updated!',
    toast_success_cookie_consent_service_deleted:
        'Cookie consent service "{service}" deleted!',
    toast_success_cookie_consent_services_deleted:
        'Cookie consent services "{services}" deleted!',
    toast_success_cookie_consent_services_seeded:
        'Default cookie consent services loaded!',
    toast_success_platform_email_template_updated:
        'Platform email template "{template}" updated!',
    toast_success_platform_email_template_created:
        'Platform email template "{template}" created!',
    toast_success_platform_email_template_deleted:
        'Platform email template "{template}" deleted!',
    toast_success_platform_email_templates_deleted:
        'Platform email templates "{templates}" deleted!',
    toast_success_platform_email_template_sent:
        'Platform email template "{template}" sent!',
    toast_success_platform_disclaimer_updated:
        'Platform disclaimer "{disclaimer}" updated!',
    toast_success_platform_disclaimer_created:
        'Platform disclaimer "{disclaimer}" created!',
    toast_success_platform_disclaimer_deleted:
        'Platform disclaimer "{disclaimer}" deleted!',
    toast_success_platform_disclaimers_deleted:
        'Platform disclaimers "{disclaimers}" deleted!',
    toast_success_transmit_asset: 'Assets successfully transmitted!',
    toast_success_asset_created: 'Asset created!',
    toast_error_cannot_delete_asset: 'Asset could not be removed!',
    toast_success_asset_deleted: 'Asset removed successfully!',
    toast_success_assets_deleted: 'Assets were removed successfully!',
    toast_success_campaign_created: 'Campaign created!',
    toast_success_campaign_duplicated: 'Campaign duplicated!',
    toast_success_asset_saved: 'Asset was saved successfully!',
    toast_success_campaign_saved: 'Campaign was saved successfully!',
    toast_success_asset_document_updated:
        'Asset document "{document}" updated!',
    toast_success_asset_document_created:
        'Asset document "{document}" created!',
    toast_success_asset_document_deleted:
        'Asset document "{document}" deleted!',
    toast_success_asset_documents_deleted:
        'Asset documents "{documents}" deleted!',
    toast_success_ad_hoc_email_sent: 'Ad-hoc email sent!',
    toast_success_run_inclusive_acceptance: 'Acceptance started: {log}',
    toast_success_run_exclusive_acceptance:
        'Exclusive acceptance process has been started: {log}',
    toast_success_transfer_tokens_success: 'Start Nyala token transfer: {log}',
    toast_success_associate_orders:
        'Associated {orders} orders with contract {contract}.',
    toast_success_campaign_content_image_deleted:
        'Content image {contentImage} deleted!',
    toast_success_campaign_content_images_deleted:
        'Content images {contentImages} deleted!',
    toast_success_campaign_content_image_created:
        'Content image {contentImage} created!',
    toast_success_campaign_content_document_deleted:
        'Content document {contentDocument} deleted!',
    toast_success_campaign_content_documents_deleted:
        'Content documents {contentDocuments} deleted!',
    toast_success_campaign_content_document_created:
        'Content document {contentDocument} created!',
    toast_success_campaign_content_block_updated:
        'Content block {contentBlock} updated!',
    toast_success_campaign_content_block_created:
        'Content block {contentBlock} created!',
    toast_success_campaign_content_block_deleted:
        'Content block {contentBlock} deleted!',
    toast_success_campaign_content_blocks_deleted:
        'Content blocks {contentBlocks} deleted!',
    toast_success_campaign_team_member_created:
        'Team member {teamMember} created!',
    toast_success_campaign_team_member_updated:
        'Team member {teamMember} updated!',
    toast_success_campaign_team_member_deleted:
        'Team member {teamMember} deleted!',
    toast_success_campaign_team_members_deleted:
        'Team members {teamMembers} deleted!',
    toast_success_order_attachment_deleted:
        'Order attachments {attachment} deleted!',
    toast_success_order_attachments_deleted:
        'Order attachments {attachments} deleted!',
    toast_success_order_attachment_updated:
        'Order attachment {attachment} updated',
    toast_success_order_attachment_created:
        'Order attachment {attachment} created',
    toast_success_order_status_changed: 'Order {order} status changed!',
    toast_success_order_updated: 'Order {order} updated!',
    toast_success_order_created: 'Order created!',
    toast_success_orders_status_changed: 'Orders {orders} status changed!',
    toast_success_campaign_deleted: 'Campaign successfully removed!',
    toast_success_campaigns_deleted: 'Campaigns successfully removed!',
    toast_success_contract_saved: 'Contract {contract} updated',
    toast_success_contract_deleted: 'Contract {contract} successfully removed!',
    toast_success_contracts_deleted:
        'Contracts {contracts} successfully removed!',
    toast_success_interest_payment_execute:
        'Interest Payment created successfully!',
    toast_success_interest_payment_payout_started: 'Payment payout started!',
    toast_success_withdrawal_created: 'Withdrawal added successfully!',
    toast_error_withdrawal_creation_failed: 'Withdrawal creation failed!',
    toast_success_natural_profile_updated:
        'Natural Profile update successfull!',
    toast_error_natural_profile_update_failed: 'Natural Profile update failed!',
    toast_success_kyc_document_created: 'Upload successfull!',
    toast_error_kyc_document_create: 'Upload failed!',
    toast_success_legal_profile_updated: 'Legal profile updated successfully',
    toast_error_legal_profile_update_failed: 'Legal profile update failed!',
    toast_error_wallet_sync_failed: 'Wallet sync failed!',
    toast_success_wallet_synced: 'Wallet sync successfull!',
    toast_success_orders_campaign_changed: 'Orders {orders} campaign changed!',
    toast_success_natural_profile_deleted: 'DSGVO deleted!',
    toast_success_legal_profile_deleted: 'Account deleted!',
    toast_success_legal_account_created: 'Legal Account created!',
    toast_success_account_created: 'Acocunt created!',
    toast_success_kyc_document_updated: 'KYC document updated successfully!',
    toast_success_campaign_status_changed:
        'Campaign status changed successfully!',

    toast_error_kyc_document_updated: 'KYC document update failed!',
    toast_success_campaign_incentive_created:
        'Campaign incentive created successfully!',
    toast_success_campaign_incentive_updated:
        'Campaign incentive updated successfully!',
    toast_success_asset_push_to_zoho: 'Asset pushed to Zoho successfully!',
    toast_success_assets_push_to_zoho: 'Assets pushed to Zoho successfully!',
    toast_success_investor_push_to_zoho:
        'Investor pushed to Zoho successfully!',
    toast_success_investors_push_to_zoho:
        'Investors pushed to Zoho successfully!',
    toast_success_investment_push_to_zoho:
        'Investment pushed to Zoho successfully!',
    toast_success_investments_push_to_zoho:
        'Investments pushed to Zoho successfully!',

    warning_failed_transactions_count:
        'Warning: Failed transactions count: {count}.',
    warning_missing_iban:
        'Warning: No IBAN was specified for {count} order(s).',
    warning_missing_bic: 'Note: No BIC was specified for {count} order(s).',
    warning_order_failed_transactions_count:
        'Failed transactions count: {count}',
    warning_order_missing_iban: 'No IBAN',
    warning_order_missing_bic: 'No BIC',

    // Enums //

    // CampaignStatus //
    DRAFT: 'Draft',
    ANNOUNCEMENT: 'Announcement',
    PRE_FUNDING: 'Pre-Funding',
    FUNDING: 'Funding',
    FUNDING_SUCCESSFUL: 'Successful',
    FUNDING_UNSUCCESSFUL: 'Unsuccessful',
    PRIVATE_PLACEMENT: 'Private placement',

    // RegulatoryRequirements //
    DEFAULT: 'Default',
    ALTFG: 'AltFG',
    VERMANLG: 'VermAnlG',
    WPHG: 'WpHG-Aktien',
    ECSP: 'ECSP',

    // AgioDisagio //
    DEACTIVATED: 'Disabled',
    AGIO_ACTIVATED: 'Agio',
    DISAGIO_ACTIVATED: 'Disagio',

    // Contract type
    CASH: 'Cash',
    VOUCHER: 'Voucher',

    // Campaign Badge
    NEW: 'Neu',
    WE_LOVE_THIS: 'We love this',
    FAVORITE: 'Favorite',
    STARTING_SOON: 'Started bald',
    IMPACT_INVESTMENT: 'Impact Investment',
    FUNDING_THRESHOLD_REACHED: 'Funding threshold reached',

    // Order Attachment Type
    INVESTMENT_DOCUMENT: 'Investment document',
    OTHER: 'Other',

    // SignatureDocumentType
    EMISSION: 'Emission',
    ESAC_FORM_A: 'Anlegerprofil (FORM A)',
    ESAC_FORM_B: 'Declaration of Beneficial Owner (Form B)',
    ESAC_FORM_C: 'FATCA Declaration (Form C)',
    ESAC_FORM_D: 'FATCA Declaration (Form D)',

    // SignatureType
    MANUAL: 'Manual',
    SPROOF: 'Sproof',

    // OrderStatus
    CANCELED: 'Canceled',
    PENDING: 'Pending',
    PAID: 'Paid',
    ACCEPTED: 'Accepted',

    // ContractPeriodType
    FIXED: 'Fixed',
    CONTINUOUS: 'Continuous',

    // ContractPeriodStart
    CURRENT: 'current',
    NEXT: 'next',

    // InterestRateCalculationMethod
    IR_ACT_360: 'ACT/360',
    IR_ACT_365: 'ACT/365',
    IR_30_360: '30/360',

    // CalculationStartDate
    ACCEPTANCE_DATE: 'Acceptance date',
    PAID_DATE: 'Paid date',

    // PayoutTaskFinishedType
    SUCCESS: 'success',
    WARNING: 'warning',
    HAS_ERRORS: 'has-errors',
    ERROR: 'error',
    ERROR_WHILE_GENERATING: 'Error while generating',

    // Accounts
    MALE: 'male',
    FEMALE: 'female',
    NON_BINARY: 'non binary',

    // ECSP Status
    EXPERT: 'expert',
    NON_EXPERT: 'non-expert (rejected)',
    EXPERT_PENDING: 'non-expert (need to be checked)',
    NOTHING_TO_CHECK: 'nothing to check',

    // KYC Document Type
    PASSPORT: 'passport',
    INVOICE: 'invoice',
    ID_CARD: 'id card',
    RESIDENCE_CONFIRMATION: 'residence confirmation',
    BANK_STATEMENT: 'bank statement',
    SDD_MANDATE: 'sdd mandate',
    COMPANY_REGISTRATION: 'company registration',
    ARTICLES_OF_ASSOCIATION: 'articles of association',
    ASSOCIATION_REGISTER_EXTRACT: 'Commercial/Association Register Extract',
    LIST_OF_SHAREHOLDERS: 'List of Shareholders',
    ID_OF_BENEFICIAL_OWNERS: 'ID of Beneficial Owners',
    ID_OF_MANAGING_DIRECTOR: 'ID of Managing Director',
    PROOF_OF_AUTHORITY_TO_REPRESENT: 'Proof of Authority to Represent',
    KYC_OTHER: 'other',

    // KYC Document Status
    KYC_DOC_STATUS_IN_PROGRESS: 'in progress',
    KYC_DOC_STATUS_ON_HOLD: 'on hold',
    KYC_DOC_STATUS_ACCEPTED: 'accepted',
    KYC_DOC_STATUS_NOT_ACCEPTED: 'rejected',
    KYC_DOC_STATUS_UNREADABLE: 'unreadable',
    KYC_DOC_STATUS_EXPIRED: 'expired',
    KYC_DOC_STATUS_WRONG_TYPE: 'wrong type',
    KYC_DOC_STATUS_WRONG_NAME: 'wrong name',
    KYC_DOC_STATUS_DUPLICATE_DOCUMENT: 'duplicate document',

    // KYC FIELD RESTRICTION MODE
    SIMPLE_FIELD_RESTRICTION:
        'Simple Field Restriction (name, date of birth, nationality, gender)',

    // Bank Account Status
    VERIFICATION_PENDING: 'verification pending',
    VERIFIED: 'verified',
    REJECTED: 'rejected',

    // MONEY WITHDRAWAL STATUS
    WITHDRAWAL_PENDING: 'Pending',
    WITHDRAWAL_DONE: 'Done',
    WITHDRAWAL_REJECTED: 'Rejected',

    // PrimaryUserRoles
    DEVELOPER: 'Developer',
    SUPERADMIN: 'Superadmin',
    PLATFORM_ADMIN: 'Platform Admin',
    FRONTOFFICE_MANAGER: 'Frontoffice Manager',
    BACKOFFICE_MANAGER_CONDA: 'Backoffice Manager Conda',
    BACKOFFICE_MANAGER_WL: 'Backoffice Manager WL',
    READ_ONLY: 'Read only',

    WALLET_STATUS_SC: 'SC Wallet',
    WALLET_STATUS_NOT_OPENED: 'Not opened',
    WALLET_STATUS_INCOMPLETE: 'Incomplete',
    WALLET_STATUS_REJECTED: 'Rejected',
    WALLET_STATUS_KYC1: 'KYC 1',
    WALLET_STATUS_KYC2: 'KYC 2',
    WALLET_STATUS_KYC3: 'KYC 3',
    WALLET_STATUS_EXPIRED: 'Expired',
    WALLET_STATUS_BLOCKED: 'Blocked',
    WALLET_STATUS_CLOSED: 'Closed',
    WALLET_STATUS_KYC_UPDATING_2_3: 'Updating from KYC 2 to 3',
    WALLET_STATUS_ONE_TIME_CUSTOMER: 'One time customer',
    WALLET_STATUS_CROWDLENDING: 'Crowdlending Wallet',
    WALLET_STATUS_TECHNIQUE: 'Technique Wallet',
    WALLET_STATUS_UNDEFINED: 'Account has no wallet',

    // ACCOUNT TYPE
    LEGAL: 'legal',
    NATURAL: 'natural',

    // EXTERNAL KYC STATUS
    EXTERNAL_KYC_CREATED: 'created',
    EXTERNAL_KYC_PENDING: 'pending',
    EXTERNAL_KYC_IN_REVIEW: 'in_review',
    EXTERNAL_KYC_SUCCESS: 'success',
    EXTERNAL_KYC_DONE: 'done',
    EXTERNAL_KYC_FAILED_CANCELED: 'failed_canceled',
    EXTERNAL_KYC_FAILED_FRAUDULENT: 'failed_fraudulent',

    // PAYMENT METHODS
    PAYMENT_METHOD_BANK_CARD: 'Bank Card',
    PAYMENT_METHOD_INCOMING_WIRE_TRANSFER: 'Incoming Wire Transfer',
    PAYMENT_METHOD_OUTGOING_WIRE_TRANSFER: 'Outgoing Wire Transfer',
    PAYMENT_METHOD_P2P: 'P2P',
    PAYMENT_METHOD_IDEAL: 'iDEAL',
    PAYMENT_METHOD_SEPA_DIRECT: 'SEPA Direct Debit',
    PAYMENT_METHOD_CHEQUE: 'Cheque',
    PAYMENT_METHOD_NEOSURF: 'Neosurf',
    PAYMENT_METHOD_SOFORT: 'SOFORT',
    PAYMENT_METHOD_PFS_PHYSICAL_CARD: 'PFS Physical Card',
    PAYMENT_METHOD_MULTIBANCO: 'Multibanco',
    PAYMENT_METHOD_PAYSHOP: 'Payshop',
    PAYMENT_METHOD_MB_WAY: 'MB WAY',
    PAYMENT_METHOD_POLISH_INSTANT_TRANSFER: 'Polish Instant Transfer',
    PAYMENT_METHOD_PAGARE: 'Pagare',
    PAYMENT_METHOD_MOBILE_PAY: 'Mobile Pay',
    PAYMENT_METHOD_PAY_TRAIL: 'PayTrail',
    PAYMENT_METHOD_WE_CHAT: 'WeChat (via PayTend)',
    PAYMENT_METHOD_P24: 'P24',
    PAYMENT_METHOD_MONEY_IN_BY_TPE: 'Money In by TPE',
    PAYMENT_METHOD_TRUSTLY: 'Trustly',

    // PaymentMethod enum labels (looked up by bare key via getEnumLabel/mapEnumToArray)
    BANK_CARD: 'Bank Card',
    INCOMING_WIRE_TRANSFER: 'Incoming Wire Transfer',
    OUTGOING_WIRE_TRANSFER: 'Outgoing Wire Transfer',
    IDEAL: 'iDEAL',
    SEPA_DIRECT: 'SEPA Direct Debit',
    CHEQUE: 'Cheque',
    NEOSURF: 'Neosurf',
    SOFORT: 'SOFORT',
    PFS_PHYSICAL_CARD: 'PFS Physical Card',
    MULTIBANCO: 'Multibanco',
    PAYSHOP: 'Payshop',
    MB_WAY: 'MB WAY',
    POLISH_INSTANT_TRANSFER: 'Polish Instant Transfer',
    PAGARE: 'Pagare',
    MOBILE_PAY: 'Mobile Pay',
    PAY_TRAIL: 'PayTrail',
    WE_CHAT: 'WeChat (via PayTend)',
    P24: 'P24',
    MONEY_IN_BY_TPE: 'Money In by TPE',
    TRUSTLY: 'Trustly',

    // OPEN BASKET STEPS
    STEP_1_INSTALMENT: 'Step 1 (CF - Instalment)',
    STEP_1: 'Step 1',
    STEP_2: 'Step 2',
    STEP_3: 'Step 3',
    STEP_4: 'Step 4',

    // TRANSACTION TYPES
    MONEY_IN: 'Money In',
    MONEY_OUT: 'Money Out',
    P2P: 'Transfer',

    // INTERNAL TRANSACTION STATUS
    SUCCESS_MONEY_IN_OUT_OR_PENDING_P2P: 'Successful',
    SUCCESS_P2P_OR_MONEY_IN_OUT_ERROR: 'Successful',
    CANCELLED: 'Cancelled',
    TRANSACTION_ERROR: 'Transaction error',
    WAIT_FOR_VALIDATION_FINALIZATION: 'Pending',
    // E-MAILS
    EMAIL_TEMPLATE_WELCOME: 'Welcome',
    EMAIL_TEMPLATE_KYC_ACCEPTED: 'KYC accepted',
    EMAIL_TEMPLATE_CHECK_REQUESTED_MEMBERSHIP_DOCUMENTS:
        'Requested Membership Documents',
    EMAIL_TEMPLATE_MEMBERSHIP_DOCUMENT_ACCEPTED: 'Membership document accepted',
    EMAIL_TEMPLATE_MEMBERSHIP_DOCUMENT_REMINDER: 'Membership document reminder',
    EMAIL_TEMPLATE_NEWSLETTER_CONSENT: 'E-Mail Newsletter Consent',
    EMAIL_TEMPLATE_CONSUMER_INFORMATION: 'Consumer Information',
    EMAIL_TEMPLATE_GIFT_CONSUMER_INFORMATION: 'Gift Consumer Information',
    EMAIL_TEMPLATE_ACCEPTANCE_NOTICE: 'Acceptance Notice',
    EMAIL_TEMPLATE_PAYMENT_CONFIRMATION: 'Payment Confirmation',
    EMAIL_TEMPLATE_PAYMENT_DETAILS: 'Payment Details',
    EMAIL_TEMPLATE_PAYMENT_REMINDER: 'Payment Reminder',
    EMAIL_TEMPLATE_SAVINGS_PLAN_PAYMENT_REMINDER:
        'Savings Plan Payment Reminder',
    EMAIL_TEMPLATE_KYC_REMINDER: 'KYC Reminder',
    EMAIL_TEMPLATE_KYC_STATUS: 'KYC Status Change',
    EMAIL_TEMPLATE_BASKET_REMINDER_ONE: 'Incomplete Order Reminder 1',
    EMAIL_TEMPLATE_BASKET_REMINDER_TWO: 'Incomplete Order Reminder 2',
    EMAIL_TEMPLATE_AUTH_EMAIL_ADDRESS_CHANGED: 'Email Change Notification',
    EMAIL_TEMPLATE_AUTH_EMAIL_VERIFICATION: 'Email Change Verification',
    EMAIL_TEMPLATE_BANK_ACCOUNT_INFORMATION_REMINDER:
        'Bank Account Information Reminder',
    EMAIL_TEMPLATE_PRE_CONSUMER_INFORMATION: 'Pre Consumer Information',
    EMAIL_TEMPLATE_SIGNATURE_REMINDER: 'Signature Reminder',
    EMAIL_TEMPLATE_SIGNATURES_REGENERATED: 'Signature Regenerated',
    EMAIL_TEMPLATE_SIGNATURE_SUCCESSFUL: 'Signature Successful',
    EMAIL_TEMPLATE_EXTERNAL_KYC_STATUS_PENDING:
        'External KYC Status Notification - Pending',
    EMAIL_TEMPLATE_EXTERNAL_KYC_STATUS_SUCCESS:
        'External KYC Status Notification - Success',
    EMAIL_TEMPLATE_EXTERNAL_KYC_PROCESS_ABORTED: 'External KYC Process aborted',
    EMAIL_TEMPLATE_KYC_EXPIRE_REMINDER: 'KYC Expire Reminder',
    EMAIL_TEMPLATE_MONEY_WITHDRAWAL_VERIFICATION:
        'Money Withdrawal - Verification',
    EMAIL_TEMPLATE_INTEREST_PAYMENT_ANNOUNCEMENT:
        'Interest Payment - Announcement',
    EMAIL_TEMPLATE_INTEREST_PAYMENT_PAYOUT_RECEIVED:
        'Interest Payment - Payout Received',
    EMAIL_TEMPLATE_EMPTY_OPTION: 'No Email Template',
    EMAIL_TEMPLATE_VOUCHER_RECEIVED: 'Voucher Received',
    EMAIL_TEMPLATE_NO_IBAN_REMINDER: 'Ad-hoc IBAN-Reminder',
    EMAIL_TEMPLATE_FEEDBACK_REVIEW: 'Feedback / Review',
    EMAIL_TEMPLATE_VOUCHER_BALANCE: 'Voucher Balance Notification',
    EMAIL_TEMPLATE_WALLET_BALANCE: 'Wallet Balance Notification',
    EMAIL_TEMPLATE_ORDER_CANCELLED:
        'Order Cancelled (Notification to Recipients)',
    EMAIL_TEMPLATE_ORDER_CANCELLED_INVESTOR_CONFIRMATION:
        'Order Cancelled (Confirmation to Investor)',
    EMAIL_TEMPLATE_CORPORATE_ACCOUNT_CREATED: 'Corporate Account Created',
    EMAIL_TEMPLATE_CORPORATE_DOCUMENTS_SUBMITTED:
        'Corporate Documents Submitted',

    EMAIL_TEMPLATE_SM_BUYER_PAYMENT_PAID: 'Buyer payment received (SM)',
    EMAIL_TEMPLATE_SM_BUY_REQUEST_EXPIRED: 'Buy request expired (SM)',
    EMAIL_TEMPLATE_SM_BUY_REQUEST_RECEIVED: 'New buy request received (SM)',
    EMAIL_TEMPLATE_SM_CHAT_MESSAGE: 'New chat message (SM)',
    EMAIL_TEMPLATE_SM_LISTING_CANCELLED: 'Listing cancelled (SM)',
    EMAIL_TEMPLATE_SM_LISTING_EXPIRED: 'Listing expired (SM)',
    EMAIL_TEMPLATE_SM_OFFER_ACCEPTED: 'Offer accepted (SM)',
    EMAIL_TEMPLATE_SM_OFFER_RECEIVED: 'New offer received (SM)',
    EMAIL_TEMPLATE_SM_OFFER_REJECTED: 'Offer rejected (SM)',
    EMAIL_TEMPLATE_SM_OFFER_EXPIRED: 'Offer expired (SM)',
    EMAIL_TEMPLATE_SM_SIGN_PROCESS_COMPLETED: 'Signing process completed (SM)',
    EMAIL_TEMPLATE_SM_TRANSACTION_COMPLETED:
        'Transaction completed successfully (SM)',
    EMAIL_TEMPLATE_SM_TRANSACTION_FAILED: 'Transaction failed (SM)',
    EMAIL_TEMPLATE_SM_TRANSACTION_WAITING_FOR_APPROVAL:
        'Waiting for approval (SM)',

    EPC: 'EPC',
    SWISS: 'Swiss',

    // Platform Policies
    TERMS_OF_SERVICE: 'Terms of Service',
    COOKIE_POLICY: 'Cookie Policy',

    // Cookie Consent Service Categories
    ESSENTIAL: 'Essential',
    FUNCTIONAL: 'Functional',
    MARKETING: 'Marketing',
    EXTERNAL_MEDIA: 'External Media',

    // Cookie Consent Service Provider Keys
    CONDA: 'CONDA',
    ZOHO: 'Zoho',
    ZOHO_BOOKINGS: 'Zoho Bookings',
    ZOHO_SURVEY: 'Zoho Survey',
    ZOHO_PAGESENSE: 'Zoho PageSense',
    ZOHO_FORMS: 'Zoho Forms',
    JENTIS: 'Jentis',
    HOTJAR: 'Hotjar',
    GOOGLE_ANALYTICS: 'Google Analytics',
    GOOGLE_ADS_CONVERSIONS: 'Google Ads Conversions',
    GOOGLE_ANALYTICS_AUDIENCES: 'Google Analytics Audiences',
    GOOGLE_ADS_REMARKETING: 'Google Ads Remarketing',
    META_PIXEL: 'Meta Pixel',
    TWITTER_TAG: 'Twitter/X Tag',
    LINKEDIN_INSIGHT: 'LinkedIn Insight',
    FACEBOOK: 'Facebook',
    INSTAGRAM: 'Instagram',
    GOOGLE_MAPS: 'Google Maps',
    OPEN_STREET_MAP: 'OpenStreetMap',
    VIMEO: 'Vimeo',
    X_EMBED: 'X Embed',
    YOUTUBE: 'YouTube',
    TRUST_INDEX: 'Trust Index',

    // Asset Categories
    STARTUP: 'Startup',
    SME: 'SME',
    REAL_ESTATE: 'Real Estate',
    SPECIAL: 'Special',
    STOCK_EMISSION: 'Stock Emission',

    // AssetClass
    PARTICIPATION_CERT: 'Participation Certificate',
    COOPERATIVE_SHARE: 'Cooperative Share',
    PROFIT_PARTICIPATION: 'Profit Participation Certificate',
    PROFIT_PARTICIPATION_SPV: 'Indirect Participation',
    BOND: 'Bond',
    CONVERTIBLE_BOND: 'Convertible Bond',
    SUBORDINATED_LOAN: 'Subordinated Loan',

    // AssetRegulation
    FINMA: 'FINMA',
    STANDORTFOEG: 'StaFöG',

    // TransferRestriction
    NONE: 'None',
    VINCULATION: 'Vinculation',
    LOCKUP: 'Lock-up',

    // SpvLegalForm
    GMBH: 'GmbH',
    AG: 'AG',
    TRUST: 'Trust',

    // IssuerIndustry
    AGRICULTURE: 'Agriculture',
    ENERGY_AND_UTILITIES: 'Energy and utilities',
    MINING: 'Mining',
    CONSTRUCTION: 'Construction',
    INDUSTRY: 'Industry',
    TRADE_AND_RETAIL: 'Trade and retail',
    HOSPITALITY_AND_TOURISM: 'Hospitality and tourism',
    TRANSPORTATION_AND_LOGISTICS: 'Transportation and logistics',
    FINANCE_AND_INSURANCE: 'Finance and insurance',
    INFORMATION_TECHNOLOGY: 'Information Technology',
    HEALTHCARE: 'Healthcare',
    EDUCATION_AND_RESEARCH: 'Education and research',

    // IssuerStatus
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    IN_LIQUIDATION: 'In liquidation',
    INSOLVENT: 'Insolvent',
    BUSINESS_LICENSES_DELETED: 'Business licenses deleted',

    // IssuerStatusInternal
    //ACTIVE: 'Active',
    //INACTIVE: 'Inactive',
    SETTLED: 'Settled',
    UNDER_OBSERVATION: 'Under observation',

    //AssetSubStatus
    REPORTING_DELAY: 'Reporting Delay',
    PAYMENT_OUTSTANDING: 'Payment Outstanding',
    REPAID: 'Repaid',
    EARLY_REPAYMENT: 'Early Repayment',

    //MinimumInvestmentType
    SHARES: 'Shares',
    AMOUNT: 'Amount',

    //StockType
    REGISTERED_SHARES: 'Registered Shares',
    BEARER_SHARES: 'Bearer Shares',
    COMMON_SHARES: 'Common Shares',
    PREFERRED_SHARES: 'Preferred Shares',

    // AgioDisagioType
    PERCENT: 'Percent',
    FIXED_VALUE: 'Fixed value',
    FIXED_VALUE_PER_SHARE: 'Fixed value per share',

    // CampaignUseOfFundsBadge
    EXCLUDED: 'Excluded',
    REDUCED: 'Reduced',
    INCREASED: 'Increased',

    // NaturalProfileActive
    NATURAL_PROFILE_ACTIVE: 'Natural Profile active',
    NATURAL_PROFILE_DEACTIVATED: 'Natural Profile deactivated',

    // VoucherType
    GIFT_VOUCHER: 'Gift voucher',
    LOYALTY_CARD: 'Loyalty card',
    DISCOUNT_VOUCHER: 'Discount voucher',

    // MembershipDocumentStatusType
    REQUESTED: 'Requested',
    SENT: 'Sent',

    // End of Enums //

    // Languages
    de: 'German',
    en: 'English',
    fr: 'French',
    it: 'Italian',
    pl: 'Polish',
    sl: 'Slovenian',
    sk: 'Slovak',
    sr: 'Serbian',

    // New translations
    help_platform_logo: 'Upload the platform logo.',
    active_emails: 'Active emails',
    mail_active_acceptance_notice: 'Mail active acceptance notice',
    help_mail_active_acceptance_notice:
        'Toggle to activate sending the acceptance notice email.',
    mail_active_bank_account_information_reminder:
        'Mail active bank account information reminder',
    help_mail_active_bank_account_information_reminder:
        'Toggle to activate sending the bank account information reminder email. Below you can select the duration of the reminder.',
    mail_active_basket_reminder: 'Mail active basket reminder',
    help_mail_active_basket_reminder:
        'Toggle to activate sending the basket reminder email.',
    mail_active_consumer_information: 'Mail active consumer information',
    help_mail_active_consumer_information:
        'Toggle to activate sending the consumer information email.',
    mail_active_gift_consumer_information:
        'Mail active gift consumer information',
    help_mail_active_gift_consumer_information:
        'Toggle to activate sending the gift consumer information email.',
    mail_active_external_kyc_status_pending: 'Mail External KYC status pending',
    help_mail_active_external_kyc_status_pending:
        'Toggle to activate sending the external kyc status pending email.',
    mail_active_external_kyc_status_success: 'Mail External KYC status success',
    help_mail_active_external_kyc_status_success:
        'Toggle to activate sending the external kyc status success email.',
    mail_active_external_kyc_process_aborted:
        'Mail External KYC process aborted',
    help_mail_active_external_kyc_process_aborted:
        'Toggle to activate sending the external kyc process aborted email.',
    mail_active_kyc_expire_reminder: 'Mail active KYC Expire Reminder',
    help_mail_active_kyc_expire_reminder:
        'Toggle to activate sending the KYC expire reminder email.',
    mail_active_interest_payment_announcement:
        'Mail active interest payment announcement',
    help_mail_active_interest_payment_announcement:
        'Toggle to activate sending the interest payment announcement email.',
    mail_active_interest_payment_payout_received:
        'Mail active interest payment payout received',
    help_mail_active_interest_payment_payout_received:
        'Toggle to activate sending the interest payment payout received email.',
    mail_active_kyc_reminder: 'Mail active kyc reminder',
    help_mail_active_kyc_reminder:
        'Toggle to activate sending the kyc reminder email.',
    mail_active_kyc_status: 'Mail active kyc status',
    help_mail_active_kyc_status:
        'Toggle to activate sending the kyc status email.',
    mail_active_no_iban_reminder: 'Mail active no iban reminder',
    help_mail_active_no_iban_reminder:
        'Toggle to activate sending the no iban reminder email.',
    mail_active_payment_confirmation: 'Mail active payment confirmation',
    help_mail_active_payment_confirmation:
        'Toggle to activate sending the payment confirmation email.',
    mail_active_payment_details: 'Mail active payment details',
    help_mail_active_payment_details:
        'Toggle to activate sending the payment details email.',
    mail_active_payment_reminder: 'Mail active payment reminder',
    help_mail_active_payment_reminder:
        'Toggle to activate sending the payment reminder email.',
    mail_active_pre_consumer_information:
        'Mail active pre consumer information',
    help_mail_active_pre_consumer_information:
        'Toggle to activate sending the pre consumer information email.',
    mail_active_signature_reminder: 'Mail active signature reminder',
    help_mail_active_signature_reminder:
        'Toggle to activate sending the signature reminder email.',
    mail_active_signature_successful: 'Mail active signature successful',
    help_mail_active_signature_successful:
        'Toggle to activate sending the signature successful email.',
    mail_active_signatures_regenerated: 'Mail active signatures regenerated',
    help_mail_active_signatures_regenerated:
        'Toggle to activate sending the signatures regenerated email.',
    mail_active_voucher_received: 'Mail active voucher received',
    help_mail_active_voucher_received:
        'Toggle to activate sending the voucher received email.',
    mail_active_welcome: 'Welcome',
    mail_active_membership_document_reminder:
        'Mail active membership document reminder',
    help_mail_active_membership_document_reminder:
        'Toggle to activate sending the membership document reminder email.',
    help_mail_active_welcome: 'Toggle to activate sending the welcome email.',
    mail_active_feedback_review: 'Mail active feedback review',
    help_mail_active_feedback_review:
        'Toggle to activate sending the feedback review email.',
    mail_active_voucher_balance: 'Mail active voucher balance',
    help_mail_active_voucher_balance:
        'Toggle to activate sending the voucher balance notification email.',
    mail_active_wallet_balance: 'Mail active wallet balance',
    help_mail_active_wallet_balance:
        'Toggle to activate sending the wallet balance notification email.',

    digital_signature_types: 'Digital signature type',
    help_digital_signature_types:
        'Signature method investors must use to sign. Leave empty to allow any method.',
    require_qualified_signature: 'Qualified Electronic Signature (QES)',
    require_advanced_qualified_signature: 'Advanced Electronic Signature (AES)',

    qr_code_type: 'QR-Code Type',
    payment_qr_code_type: 'Payment qr code type',
    help_payment_qr_code_type: 'The payment qr code type',

    payment_methods: 'Payment Methods',
    credit_card: 'Credit card',
    wire_transfer: 'Wire transfer',

    confirm_kyc_company_details: 'Confirm KYC company details',
    reject_kyc_company_details: 'Reject KYC company details',
    toast_success_update_legal_profile_kyc_legal_confirmed: 'KYC confirmed',
    toast_success_update_legal_profile_kyc_legal_rejected: 'KYC rejected',
    toast_error_update_legal_profile_kyc_legal: 'KYC update failed',

    help_order_documents_table: 'Documents related to the order.',
    help_order_reporting_documents_table:
        'Reporting documents related to the order.',
    help_kyc_id_documents: 'KYC ID documents',
    help_kyc_address_documents: 'KYC address documents',
    help_kyc_bank_documents: 'KYC bank documents',
    help_kyc_tax_documents: 'KYC tax documents',
    help_kyc_legal_documents: 'Company details for KYC.',
    esac_kyc: 'ESAC KYC',
    esac_kyc_active: 'Esac kyc active',
    help_esac_kyc_active: 'Set esac kyc active.',
    esac_form_natural_person: 'Esac form natural person',
    esac_form_legal_entity: 'Esac form legal entity',
    esac_form_legal_ubo: 'Esac form legal ubo',
    modal_title_delete_file: 'Delete file?',
    modal_text_delete_file: 'Are you sure you want to delete {file}?',

    mail_type_standard: 'Standard',
    help_mail_template: 'Select the email template to use.',
    mail_template_color: 'Email template color',
    help_mail_template_color: 'General color for platform emails.',
    primary_color: 'Primary color',
    help_primary_color: 'The main brand color used across the platform theme.',
    badge_colors: 'Badge colors',
    help_badge_colors:
        'Colors used for the asset regulation and gebundener-Vermittler badges/borders shown on campaign cards.',
    badge_color_ecsp: 'ECSP',
    help_badge_color_ecsp: 'Badge/border color for the ECSP regulation.',
    badge_color_vermanlg: 'AltFG & VermAnlG',
    help_badge_color_vermanlg:
        'Badge/border color for the AltFG & VermAnlG regulation.',
    badge_color_finma: 'FINMA',
    help_badge_color_finma: 'Badge/border color for the FINMA regulation.',
    badge_color_standortfoeg: 'StaFöG',
    help_badge_color_standortfoeg:
        'Badge/border color for the StaFöG regulation.',
    badge_color_tied_agent: 'Gebundener Vermittler',
    help_badge_color_tied_agent:
        'Badge/border color for the "Gebundener Vermittler" flag.',
    mail_template_action_button_color: 'Email template action button color',
    help_mail_template_action_button_color:
        'The action button color for platform emails.',
    mail_template_action_button_text_color:
        'Email template action button text color',
    help_mail_template_action_button_text_color:
        'The action button text color for platform emails.',

    is_realm: 'Realm',
    is_platform: 'Plattform',

    platform_assets: 'Platform Assets',
    help_platform_assets: 'The platform assets',
    toast_success_delete_asset: 'Asset deleted successfully',
    platform_campaigns: 'Platform Campaigns',
    help_platform_campaigns: 'The platform campaigns',
    toast_success_delete_campaign: 'Campaign deleted successfully',
    platform_orders: 'Platform Orders',

    asset_video: 'Video URL',
    help_asset_video: 'The video URL for the campaign.',
    help_campaign_og_title:
        'Overrides the title used for social share previews. Defaults to the title if empty.',
    help_campaign_og_description:
        'Overrides the description used for social share previews. Defaults to the excerpt if empty.',

    help_platform_compliance_profile:
        'Select the compliance profile for the platform.',

    toast_success_delete_task: 'Task deleted successfully',

    toast_success_delete_asset_contract: 'Contract deleted successfully',

    acceptance_document: 'Acceptance Document',
    acceptance_document_active: 'Acceptance Document',
    acceptance_round: 'Acceptance Round',
    acceptance_round_label: 'Acceptance – {date} ({count} order(s), {amount})',
    help_no_open_acceptance_round:
        'No open acceptance round for this asset yet — run Acceptance first.',
    mark_acceptance_round_done: 'This round is done',
    help_acceptance_document:
        'The acceptance document is automatically sent to the investors when investments are accepted.',
    help_tax_document: 'Upload the tax document for the platform.',
    help_acceptance_document_active:
        'Toggle to activate sending the acceptance document email.',
    help_platform_orders: 'The Orders of the Platform.',
    no_signature_link_available: 'No signature link available',
    country_of_residence: 'Country of Residence',
    natural_profile_uid: 'Natural Profile UID',
    legal_profile_uid: 'Legal Profile UID',

    upload: 'Upload',

    account_pep_past: 'PEP past',
    account_pep_position: 'PEP position',
    help_account_pep_position: 'The PEP position',
    account_pep_past_position: 'PEP past position',
    help_account_pep_past_position: 'The PEP position',

    modal_title_duplicate_campaign: 'Duplicate campaign',

    expand: 'Expand',
    collapse: 'Collapse',

    tasks: 'Tasks',
    help_tasks_table: 'The Tasks table',
    taskable: 'Taskable',
    result_data: 'Result data',
    result_text: 'Result text',
    expires_at: 'Expires at',
    download: 'Download',

    // Task Type
    GENERIC: 'Generic',
    INTEREST_PAYMENT_CALCULATION: 'Interest payment calculation',
    INTEREST_PAYMENT_PAYOUT: 'Interest payment payout',
    NYALA_RETRIEVE_REGISTRY_EXTRACT: 'Nyala download registry extract',
    NYALA_CREATE_REGISTRY_EXTRACT: 'Nyala create registry extract',
    PAYMENT_ACCEPTANCE: 'Payment acceptance',
    NYALA_TRANSFER_TOKEN: 'Nyala transfer token',
    EXPORT_CSV: 'Export CSV',
    EXPORT_XLSX: 'Export XLSX',
    UPLOAD_ASSET_INVESTMENT_REPORT: 'Asset investment report upload',
    UPLOAD_ASSET_SECONDARY_MARKET_IMPORT: 'Secondary Market Asset import',
    EXCLUSIVE_ACCEPTANCE: 'Exclusive acceptance',
    EXPORT_SIGNED_DOCUMENTS: 'Export signed documents',
    EXPORT_INVESTOR_KYC_FOLDER: 'Export investor KYC folder',
    SYNC_NYALA_INVESTMENT: 'Sync Nyala Investment',
    EXPORT_INTEREST_PAYMENT_SEPA_CSV: 'Export Interest payment SEPA CSV',
    EXPORT_INTEREST_PAYMENT_EXCEL: 'Export Interest payment Excel',
    ASSET_ORDERS_SET_PAID: 'Asset orders set paid',
    ASSET_ORDERS_SET_PENDING: 'Asset orders set pending',
    RELEASE_FUNDS: 'Release funds',
    SEND_OPT_INS: 'Send opt-ins',
    UPDATE_STAKEHOLDER_AMOUNT: 'Update stakeholder amount',

    // TaskStatus
    REGISTERED: 'Registered',
    STARTED: 'Started',
    FINISHED: 'Finished',
    issuer: 'Issuer',
    issuers: 'Issuers',
    issuer_name: 'Name',
    issuer_logo: 'Logo',
    issuer_website: 'Website',
    internal_status: 'Internal Status',
    issuer_details: 'Issuer Details',
    toast_error_cannot_delete_issuer: "Can't delete this issuer!",
    toast_success_issuer_deleted: 'Issuer "{issuer}" deleted!',
    toast_success_issuers_deleted: 'Issuers "{issuers}" deleted!',
    toast_success_issuer_created: 'Issuers created!',
    help_issuers_table: 'The issuers table.',
    help_issuer_platform: 'Select the platform for the issuer.',
    modal_title_delete_issuer: 'Delete issuer?',
    create_issuer: 'Create Issuer',
    help_issuer: 'The issuer of the asset',
    help_issuer_name: 'The name of the issuer.',
    help_issuer_logo: 'The company logo of the issuer.',
    issuer_status: 'Status',
    help_issuer_status: 'The status of the issuer.',
    issuer_internal_status: 'Internal Status',
    help_issuer_internal_status: 'The internal status of the issuer.',
    issuer_industry: 'Industry',
    help_issuer_industry: 'The industry of the issuer.',
    toast_success_issuer_saved: 'Issuer {issuer} saved!',

    toast_success_export_csv:
        'The CSV Export will be generated in the background. You will see the result in the "Tasks" section once it is ready.',
    toast_success_kyc_folder_export:
        'KYC folder export started. You will see the result in the "Tasks" section once it is ready.',
    toast_success_upload_csv:
        'The CSV upload will be generated in the background. You will see the result in the "Tasks" section once it is ready.',
    platform_investor_qualification: 'Investor Qualification',
    end_contract: 'End Contract',
    modal_title_end_contract: 'End Contract?',
    modal_text_end_contract:
        'Are you sure you want to end this contract early?',
    contract_end_cause: 'Contract end cause',
    help_contract_end_cause: 'The Contract end cause',
    toast_success_end_contract: 'Contract ended sucessfully!',

    help_signatures_table: 'The Signatures table',

    beneficial_owners: 'Beneficial owners',
    help_beneficial_owners: 'The Beneficial owners',
    show_signatures: 'Show signatures',
    toast_success_cancel_order: 'Order canceled successfully!',

    help_open_basket_table: 'Incomplete orders are displayed here',
    export_transactions: 'Export transactions',
    toast_success_export_transactions: 'Transactions exported successfully!',
    export_kista_request: 'Export KISTA request',
    export_membership_documents: 'Export membership documents',
    export_order_transfer_history: 'Export order transfer history',
    toast_success_export_kista_request: 'KISTA request successfully exported',
    toast_success_kista_response_import:
        'KISTA response successfully imported. Generated tax features: {newTaxFeaturesCount}',
    upload_kista_response: 'Upload KISTA response CSV',

    modal_title_task_details: 'Task details',

    total_count: 'Total count',
    error_count: 'Error count',
    modal_title_duplicate_cash_contract: 'Duplicate cash contract',
    modal_text_duplicate_cash_contract: 'Duplicate cash contract?',

    has_orders: 'Has orders',

    copy_value: 'Copy value',
    toast_success_copy_to_clipboard: 'Value copied to the clipboard!',
    toast_clipboard_manual_copy:
        'Clipboard access unavailable. Copy this link manually: {url}',
    toast_error_copy_to_clipboard: 'Copy failed, please try again.',
    order_paid_date: 'Paid date',
    order_acceptance_date: 'Acceptance date',
    order_cancellation_date: 'Cancellation am',

    need_help: 'Need help?',
    documentation: 'Documentation',
    report_a_bug: 'Report a bug',
    give_feedback: 'Give feedback',

    resend_mail: 'Resend order email',
    modal_title_resend_mail: 'Resend order email?',
    help_resend_mail: 'Choose the email to resend.',

    is_main: 'Is main',

    modal_title_view_kyc_document: 'View KYC document.',
    modal_title_view_kyc_bank_document: 'View KYC Bank document.',

    created_by: 'Created by',
    payment_account_id: 'Payment account id',
    funding_total_status: 'Funding total status',
    webhooks_activated: 'Webhooks activated',
    has_credential_simply_tokenized: 'Has Simply Tokenized credentials',
    has_credential_sproof: 'Has sproof credentials',
    has_credential_voucherify: 'Has voucherify credentials',
    compliance_profile: 'Compliance profile',
    expert_investor_treatment: 'Sophisticated investor?',

    updated_at: 'Updated at',
    investor_consent: 'Investor consent',
    contract_period: 'Contract period',
    asset_funding_count: 'Funding count',
    asset_funding_total: 'Funding total',
    asset_installment_investment: 'Installment investment',
    help_asset_installment_investment:
        'When activated, the options for intstallment investments can be set',
    asset_initial_payment: 'Initial Payment',
    asset_installment_payout: 'Installment payout',
    asset_minimum_initial_payment: 'Minimum initial payment',
    help_asset_minimum_initial_payment: 'Minimum initial payment',
    asset_maximum_initial_payment: 'Maximum initial payment',
    help_asset_maximum_initial_payment: 'Maximum initial payment',
    asset_initial_payment_step: 'Initial payment step',
    help_asset_initial_payment_step: 'Initial payment step',
    asset_installments: 'Instalments',
    asset_minimum_installment: 'Minimum installment',
    help_asset_minimum_installment: 'Minimum installment',
    asset_maximum_installment: 'Maximum installment',
    help_asset_maximum_installment: 'Maximum installment',
    asset_installment_step: 'Installment step',
    help_asset_installment_step: 'Installment step',
    asset_minimum_monthly_rates: 'Minimum monthly rates',
    help_asset_minimum_monthly_rates: 'Minimum monthly rates',
    asset_maximum_monthly_rates: 'Maximum monthly rates',
    help_asset_maximum_monthly_rates: 'Maximum monthly rates',
    asset_minimum_yearly_rates: 'Minimum yearly rates',
    help_asset_minimum_yearly_rates: 'Minimum yearly rates',
    asset_maximum_yearly_rates: 'Maximum yearly rates',
    help_asset_maximum_yearly_rates: 'Maximum yearly rates',
    asset_monthly_payments: 'Monthly payments',

    campaign_asset_needs_contract_selection: 'Asset needs contract selection',

    ended_at: 'Ended at',
    payment_dates: 'Payment dates',
    confirmed: 'Confirmed',

    last_login_date: 'Last login date',
    blocked_balance_from_orders: 'Blocked balance from orders',
    sso_user_uid: 'SSO User UID',
    custom_id: 'Custom id',
    sub_platform: 'Sub platform',
    email_pending: 'Email pending',
    mobile_number: 'Mobile number',
    newsletter_consent: 'Newsletter consent',
    help_contract_payment_dates_title: 'Please add payout dates',
    help_contract_payment_dates_text:
        'Please provide payout dates for the contract. Please make sure that these dates are after the first payout and before the last payout for "Fixed" contracts.',

    installments: 'Installments',
    disabled_on: 'Disabled on',
    current_loan_amount: 'Current loan amount',
    paid_total: 'Paid total',
    paid_total_gross: 'Paid total gross',
    paid_total_net: 'Paid total net',
    total_tax: 'Total tax',
    church_tax: 'Church tax',
    soli: 'Soli',
    tax: 'Tax',
    paid_rest: 'Paid rest',
    paid_bonus: 'Paid bonus',
    cumulative_rest: 'Cumulative rest',
    current_rest: 'Current rest',
    new_basis: 'New basis',
    search: 'Search',
    global_search_placeholder: 'Global search...',
    more_search_results: 'View more results...',
    no_languages_available_for_this_email_template:
        'No languages available for this email template.',

    subtasks: 'Subtasks',

    ecsp_status: 'ECSP Status',
    uploaded_document: 'Uploaded document',
    ecsp_document: 'ECSP document',
    ecsp_documents: 'ECSP documents',
    button_id_ecsp_document_upload: 'Upload ECSP verification document',
    modal_title_create_id_ecsp_document:
        'Upload ECSP Document for verification',
    verification_comment: 'Verification comment',
    toast_error_ecsp_document_create: 'ECSP document could not be saved!',
    toast_success_ecsp_document_updated: 'ECSP document updated successfully!',
    ecsp_id_document: 'Uploaded ECSP Document',
    help_ecsp_id_document:
        'In this table you can manage the ECSP document, tied to the compliance profile ECSP.',
    help_ecsp_status: 'Status of the ECSP verification',

    kyc_provider: 'KYC Provider',
    kyc_settings: 'KYC Settings',
    the_field_contains_unallowed_characters:
        'The field contains unallowed characters.',

    //St. Pauli
    membership_management: 'Membership management',
    membership_management_active: 'Activate membership management',
    help_membership_management_active:
        'When activated, the possibility for memberships will be enabled.',
    help_membership_management:
        'Here the settings for memeberships can be set. These allow investors to become members by doing an investment.',
    gift_membership: 'Gift membership',
    help_gift_membership:
        'Activate the Gift membership functionality in orders',
    gift_membership_faq: 'Gift membership FAQ',
    help_gift_membership_faq:
        'Here you can give the FAQ text that should be displayed in the investment process at Gift membership section.',
    gift_membership_faq_url: 'Gift membership FAQ URL',
    help_gift_membership_faq_url:
        'This URL will be displayed under Gift Membership section.',
    membership_type_manual: 'Manual',
    membership_type_sproof: 'Sproof',
    qualified_signature: 'Qualified signature',
    help_qualified_signature: 'Activate qualified signiture',
    use_rule: 'Use Rule',
    help_use_rule:
        'If this switch is enabled, only orders from investors who have an accepted membership document can be accepted.',
    order_certificate_active: 'Activate order certificate',
    help_order_certificate_active: 'Activate order certificate',
    certificates_deleted: 'Certificates deleted',
    certificate_uploaded: 'Certificate uploaded',
    membership_number_active: 'Activate membership number',
    help_membership_number_active:
        'Activate membership number in membership management',
    membership_number_prefix_natural:
        'Membership number prefix for natural profile',
    help_membership_number_prefix_natural:
        'Here you can specify which character the membership number belonging to the natural profile should start with',
    membership_number_prefix_legal:
        'Membership number prefix for legal profile',
    help_membership_number_prefix_legal:
        'Here you can specify which character the membership number belonging to the legal profile should start with',
    help_membership_number: 'Membership number',
    membership_barcode_active: 'Activate barcode',
    help_membership_barcode_active: 'Activate barcode functionality',
    upload_document: 'Upload document',
    membership_number: 'Membership number',
    membership_id_document: 'Uploaded membership document',
    help_membership_id_document: 'Here you can upload a membership document',
    modal_title_create_id_membership_document: 'Upload new membership document',
    button_id_membership_document_upload: 'Select document',
    modal_title_update_membership_document: 'Edit membership document',
    membership_document_status: 'status of the membership document',
    membership_documents_admin_email: 'Membership document admin email',
    membership_document_description: 'Membership document description',
    help_membership_document:
        'When uploaded, the investor gets a Membership Document when investments are accepted and paid.',
    help_membership_document_description:
        'Here you can enter a description for the member document. Will be displayed for customers in the Member Document area. This is to help customers know what to do with the document.',
    help_membership_document_status:
        'The status of the membership document can have 3 values: pending, accepted and rejected',
    has_membership: 'Member',
    hasnt_membership: 'Not member',
    modal_title_view_membership_document: 'Membership document',
    toast_success_membership_document_updated:
        'Membership document updated successfully!',
    toast_error_membership_document_updated:
        'Membership document could not be saved!',
    toast_error_platform_saving_membership_document_missing:
        'Platform with active membership management without membership document cannot be saved!',
    toast_success_membership_document_create:
        'Membership document updated successfully!',
    toast_error_membership_document_create:
        'Membership document could not be saved!',
    toast_success_membership_document_approved:
        'Membership document approved successfully!',
    toast_error_membership_document_approved:
        'Membership document could not be approved!',

    // Certificate
    order_certificate: 'Order Certificate',

    retrieve_nyala_registry_extract: 'Download Registry Extracts',
    modal_title_retrieve_nyala_registry_extract: 'Download Registry Extracts',
    create_nyala_registry_extract: 'Create Registry Extracts',
    modal_title_create_nyala_registry_extract: 'Create Registry Extracts',
    toast_success_create_nyala_registry_extract:
        'Registry extract creation started with Nyala. {log}',
    retrieve: 'Retrieve',
    toast_success_upload_asset_investment_report:
        'Investment report uploaded successfully.',
    send_nyala_registry_document_email: 'Send Nyala Registry Document email',
    modal_title_send_nyala_registry_document_email:
        'Send Nyala Registry Document email',
    toast_success_send_nyala_registry_document_email:
        'The Nyala Registry Document email was successfully sent.',
    update_stakeholder_amount: 'Update Stakeholder Amount',
    modal_title_update_stakeholder_amount: 'Update Stakeholder Amount',
    toast_error_closing_acceptance_rounds:
        'Failed to mark round(s) {rounds} as done. You can try again from the acceptance rounds list.',
    send_opt_ins: 'Send Opt-Ins',
    modal_title_send_opt_ins: 'Send Opt-Ins',
    release_funds: 'Release Funds',
    modal_title_release_funds: 'Release Funds',
    modal_title_transfer_tokens: 'Distribute Tokens',
    add: 'Add',
    remove: 'Remove',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    toast_success_kyc_processes_reset: 'KYC processes reset successfully!',
    toast_success_fetch_identity_token:
        'Identity token was successfully retrieved.',
    toast_success_retrieve_nyala_registry_extract:
        'Nyala Registry Extract downloaded successfully! {log}',
    toast_error_kyc_processes_reset: 'KYC processes could not be reset!',
    toast_error_fetch_identity_token: 'Identity token could not be retrieved!',
    toast_success_idv_document_download:
        'Signteq IDV document has been successfully downloaded.',
    toast_error_idv_document_download:
        'Error: could not download Signteq IDV document',
    EMAIL_TEMPLATE_NYALA_REGISTRY_FILE: 'Send Nyala Registry Documents',
    nyala_registry_documents: 'Nyala Registry Documents',
    nyala_registry_documents_help: 'The Nyala Registry Documents',
    nyala_registry_document: 'Nyala Registry Document',
    post_status: 'Delivery status',
    issuer_id: 'Issuer ID',
    asset_uid: 'Asset ID',
    campaign_id: 'Campaign ID',
    contract_uid: 'Contract ID',

    help_kyc_provider: 'The KYC provider',
    external_kyc_active: 'External KYC active',
    help_external_kyc_active:
        'Toggle to activate the external KYC on the platform.',
    kyc_field_restriction_mode: 'KYC Field Restriction Mode',
    kyc_field_restriction_mode_no_restriction: 'No restriction',
    help_kyc_field_restriction_mode:
        'Restrict editing of identity-related fields for users with KYC verification',
    api_host: 'API host',
    help_api_host: 'The API host',
    redirect_host: 'Redirect host',
    help_redirect_host: 'The redirect host',
    customer: 'Customer',
    help_customer: 'The customer',
    api_key: 'API key',
    help_api_key: 'The API key',
    signature_api_key: 'Signature API key',
    help_signature_api_key: 'The Signature API key',

    transfer_investment: 'Transfer Investment',
    help_transfer_investment:
        'Toggle to activate the transfer of accepted investments between investors.',
    help_investment_desk_settings:
        'Here you can modify all the settings for the investment desk.',
    legal_profile: 'Legal profile',
    natural_profile: 'Natural profile',
    keep_original_order: 'Keep original investment.',
    is_gift: 'Gift',
    edit_file: 'Edit file',
    success_edited_file_uploaded: 'Edited file uploaded successfully',
    error_edited_file_uploaded: 'Edited file could not be uploaded',
    no_placeholders_available: 'No placeholders available',
    show_placeholders_panel: 'Show placeholders panel',
    apply_placeholders: 'Apply placeholders',
    apply_placeholders_info:
        'This closes the editor, and applies your changes. \nYou can always edit the document again.',
    membership_document: 'Membership document',
    certificate_document: 'Certificate document',
    transaction_message: 'Transaction message',
    help_keep_original_order:
        'If selected, this action is going to cancel the old order, and create a new one. The paid_date and investment_acceptance_date will be set to current time. Keep original can only be selected if the original order is accepted.',
    help_transaction_message:
        'If the platform is connected to a payment provider and if the order is paid, this value is required because in that case we need to move funds from one wallet to another. This value is also required if the order is a gift.',
    help_transfer_investment_account_title:
        'Please select the account to which the investment should be transferred.',
    transfer_order_success: 'Investment transferred successfully!',
    profile_title: 'Profile UID',
    help_transfer_investment_profile_title:
        'Please insert the natural or legal profile UID to which the investment should be transferred.',
    bottom_help_funding_start:
        'Note: All times must be entered in UTC. The system currently does not adjust for local timezones. Please convert your local time to UTC before input. Your time is {utcOffset} of UTC time.',
    bottom_help_funding_end:
        'Note: All times must be entered in UTC. The system currently does not adjust for local timezones. Please convert your local time to UTC before input. Your time is {utcOffset} of UTC time.',
    bottom_help_funding_ahead: 'ahead',
    bottom_help_funding_behind: 'behind',
    nyala_project: 'Nyala Project',
    manage_nyala_project: 'Manage Nyala project',
    edit_nyala_project: 'Edit Nyala project',
    nyala_project_external_tokenized_asset_id: 'Tokenized asset ID',
    help_nyala_project_external_tokenized_asset_id:
        'Nyala Project Tokenized asset ID',
    nyala_project_external_project_id: 'External project ID',
    help_nyala_project_external_project_id: 'Nyala Project External project ID',
    toast_success_nyala_project_connected_to_asset:
        'Nyala project connected to asset successfully!',
    toast_success_nyala_project_connected_to_contract:
        'Nyala project connected to contract successfully!',
    all_contracts_connected_to_nyala_project:
        'All contracts connected to a Nyala project',
    contract_asset_connected_to_nyala_project:
        'Asset connected to Nyala project',
    detach_nyala_project: 'Detach Nyala Project',
    toast_success_nyala_project_detached_from_contract:
        'Nyala project successfully detached from contract!',
    nyala_project_unit_name: 'Unit name',
    help_nyala_project_unit_name: 'The name of the unit',
    nyala_project_issuer_wallet_seed_id: 'Issuer Wallet Seed ID',
    help_nyala_project_issuer_wallet_seed_id: 'The issuer wallet seed ID',
    nyala_project_issuer_wallet_id: 'Issuer Wallet ID',
    help_nyala_project_issuer_wallet_id: 'The issuer wallet ID',
    nyala_project_integration_passphrase: 'Integration passphrase',
    help_nyala_project_integration_passphrase: 'The integration passphrase',
    nyala_project_custody_provider: 'Custody provider',
    help_nyala_project_custody_provider:
        'The custody provider for nyala project',
    save: 'Save',
    nyala_customer: 'Nyala Customer',
    kyc_data_transfered: 'KYC data transfered',
    external_customer_id: 'External customer ID',
    public_address: 'Public address',
    retail_wallet_id: 'Retail wallet ID',
    retail_wallet_status: 'Retail wallet status',
    stock_details: 'Stock details',
    voting_rights_per_share: 'Voting rights per share',
    stock_emission_contract: 'Stock Emission Contract',
    fetch_signteq_identity_token: 'Fetch identity token',
    transmit_asset: 'Transmit asset',
    modal_title_transmit_asset: 'Transmit asset',
    transmit: 'Transmit',

    // Taxes
    taxes: 'Taxes',
    create_tax: 'Create tax',
    tax_name: 'Tax name',
    tax_rate: 'Tax rate',
    target: 'Target',
    base_value: 'Base value',
    tax_document: 'Tax Document',
    delete_tax_question: 'Are you sure you want to delete this tax?',
    toast_success_tax_created: 'Tax created successfully!',
    toast_success_tax_updated: 'Tax updated successfully!',
    detach: 'Detach',
    detach_nyala_project_modal_info:
        'Are you sure you want to detach this Nyala project?',
    zoho_integration: 'Zoho integration',
    workdrive_integration: 'WorkDrive integration',
    workdrive_client_id: 'WorkDrive client ID',
    workdrive_client_secret: 'WorkDrive client secret',
    workdrive_refresh_token: 'WorkDrive refresh token',
    workdrive_api_domain: 'WorkDrive API domain',
    workdrive_team_folder_id: 'WorkDrive team folder ID',
    help_zoho_sync_enabled:
        'Toggle to activate the Zoho integration and sync the platform with Zoho.',
    zoho_sync_enabled: 'Zoho sync enabled',
    inherited_from_parent: 'Inherited from parent',
    zoho_override_prompt: 'Do you want to override?',
    modal_title_send_email_template: 'Send email template',
    flatten_signature_placeholder_button: 'Flatten Signature placeholder',
    flatten_signature_placeholder_button_info:
        'This flattens the signature placeholder.\nOnce flattened, the placeholder cannot be moved or deleted.',
    signature_placeholder_info:
        'This will add a signature placeholder to the document.\nOnce flattened, the placeholder will be replaced with a Signteq signature field. \n\nOnly 1 signature placeholder is allowed per document.\n\nFlatten the signature placeholder before saving your changes!\nOnce flattened, the placeholder cannot be moved or deleted.',
    qr_code_placeholder_info:
        'This will add a QR-code placeholder to the document. \nThe placeholder field will be replaced with a QR-code. \nOnly 1 QR code placeholder is allowed per document.',
    standard_placeholder_info:
        'This will add a placeholder to the document. \nThe placeholder will be replaced with the value of the field.',

    // investment desk settings
    investment_desk_settings: 'Investment desk settings',
    use_new_theme: 'Use new theme',
    single_campaign_style: 'Single campaign style',
    lock_details_tab: 'Lock details tab',
    lock_documents_tab: 'Lock documents tab',
    lock_investors_room_tab: 'Lock investors room tab',
    show_tos_for_unauthenticated_users: 'Show TOS for unauthenticated users',
    show_minimum_investment_instead_of_minimum_funding:
        'Show minimum investment instead of minimum funding',
    hide_percentage_on_knob: 'Hide percentage on knob',
    hide_funding_indicator_on_knob: 'Hide funding indicator on knob',
    hide_funding_max_on_knob: 'Hide funding max on knob',
    show_dropdown_on_hover: 'Show dropdown on hover',
    hide_company_account: 'Hide company account',
    hide_create_company_account: 'Hide create company account',
    hide_latest_investments: 'Hide latest investments',
    show_language_select_menu_in_header: 'Show language select menu in header',
    onboarding_flow: 'Onboarding flow',
    use_v2_frontend: 'Use v2 frontend',
    use_v2_frontend_investment_process: 'Use v2 frontend investment process',
    use_v2_frontend_portfolio_dashboard: 'Use v2 frontend portfolio dashboard',
    use_v2_frontend_portfolio_investments:
        'Use v2 frontend portfolio investments',
    use_voucherify_coupon_code: 'Use voucherify coupon code',
    emission_use_asset_title_in_preview_calculation:
        'Emission use asset title in preview calculation',
    emission_hide_investment_amount_row: 'Emission hide investment amount row',
    show_contract_interest_rate_investment_process:
        'Show contract interest rate investment process',
    restrict_campaign_access_to_kyc_identity_verified_users:
        'Restrict campaign access to KYC identity verified users',
    redirect_url_after_login: 'Redirect URL after login',
    login_only_via_external_identity_provider:
        'Login only via external identity provider',
    hide_cent_values: 'Hide cent values',
    use_swiss_currency_format: 'Use Swiss currency format',
    queue_it: 'Queue it',
    queue_it_customer_id: 'Queue it customer ID',
    right_of_withdrawal: 'Right of withdrawal',
    consequences_of_revocation: 'Consequences of revocation',
    cancel_investment_policy: 'Cancel Investment Policy',
    cancel_order_button_enabled: 'Enable Cancel Order Button',
    help_cancel_order_button_enabled:
        'When enabled, investors can cancel their investment within the configured cancel period.',
    cancel_counter_start: 'Counter Start Date',
    help_cancel_counter_start:
        'The date from which the cancel period starts counting.',
    cancel_counter_start_created_at: 'Created at (order creation)',
    cancel_counter_start_paid_at: 'Investment paid at date',
    cancel_counter_start_accepted_at: 'Investment accepted at date',
    cancel_period_days: 'Cancel Period (Days)',
    cancel_contact_email: 'Revocation Email Address',
    help_cancel_contact_email:
        'Email address investors can send their revocation to. Shown in the cooling-off notice of the investment process.',
    help_cancel_period_days:
        'Total number of days the investor has to cancel their investment.',
    cancel_notification_recipients: 'Notification Recipients',
    acceptance_after_cancel_period: 'Acceptance after Cancel Period',
    help_acceptance_after_cancel_period:
        'When enabled, orders can only be accepted after their individual cancel period has elapsed.',
    payout_through_acceptance: 'Payout through Acceptance',
    help_payout_through_acceptance:
        'When enabled, the issuer is paid out at acceptance regardless of the cancel period. Overrides "Acceptance after Cancel Period".',
    warning_acceptance_after_cancel_period_accepted_at_invalid:
        'Warning: "Acceptance after Cancel Period" cannot be used with "Counter Start Date = Accepted at". The acceptance date is not known at acceptance time. Please choose "Created at" or "Paid at" instead.',
    cancel_auto_refund_enabled: 'Automatic Refund on Cancel',
    sm_marktplatz: 'Ökostrom Marketplace',
    help_sm_marktplatz: 'Secondary Marketplace',
    help_cancel_auto_refund_enabled:
        'When enabled, cancelling an investment automatically triggers a refund via Secupay (default direct debit setup). Disable this for platforms where the Secupay payout setup does not support automatic refunds.',
    utm_parameter: 'UTM parameter',
    child_platform: 'Child platform',
    campaign_additional_info: 'Campaign Additional info',
    help_campaign_additional_info:
        'Here you can enter additional information for the campaign. This will be displayed for customers in the single campaign page.',
    platform_settings: 'Platform settings',
    help_platform_settings:
        'Here you can manage all possible settings, and decide which ones to activate for your platform.',
    asset_settings: 'Asset settings',
    help_asset_settings:
        'Here you can manage all possible settings, and decide which ones to activate for your asset.',
    voucherify_enabled: 'Voucherify enabled',
    help_voucherify_enabled: 'When activated, the platform can use Voucherify',
    send_notification_mail: 'Send notification mail',
    appearance_and_content: 'Appearance and Content',
    help_appearance_and_content:
        'Here you can manage the appearance of the campaign as well as content',
    appearance: 'Appearance',
    campaign_settings: 'Campaign settings',
    help_campaign_settings:
        'Here you can manage all possible settings, and decide which ones to activate for your campaign.',
    marketing_content: 'Marketing Content',
    campaign_marketing_asset_information: 'Asset Information',
    campaign_marketing_overview: 'Overview',
    campaign_marketing_media: 'Media',
    campaign_marketing_company_presentation: 'Company presentation',
    campaign_marketing_key_facts: 'Key Facts for Investors',
    campaign_marketing_milestones: 'Achievements & milestones',
    campaign_marketing_team: 'Management Team',
    campaign_marketing_podcast: 'Podcast',
    campaign_marketing_community: 'Community',
    campaign_marketing_incentives: 'Perks',
    campaign_marketing_details: 'Details',
    campaign_marketing_business_model: 'Business Model',
    campaign_marketing_business_model_section: 'Business Model & Direct Sales',
    campaign_marketing_offerings: 'Product Portfolio & Target Groups',
    campaign_marketing_revenue_structure: 'Revenue Structure',
    campaign_marketing_competitive_advantages: 'Competitive Advantages',
    campaign_marketing_market_potential: 'Market & Market Potential',
    campaign_marketing_market_segment: 'Market Segment',
    campaign_marketing_trends: 'Trends & Growth Opportunities',
    campaign_marketing_competition: 'Competition',
    campaign_marketing_swot_analysis: 'SWOT Analysis',
    help_campaign_marketing_company_presentation:
        'Enter the overview of the company.',
    help_campaign_marketing_team: 'Enter the overview of the company team.',
    help_campaign_marketing_podcast: 'Select the podcast for the campaign.',
    help_campaign_marketing_community:
        'Enter the URL to the campaign community area.',
    campaign_marketing_news: 'News',
    help_campaign_marketing_news:
        'Select one or more news articles to connect to this campaign.',
    help_campaign_marketing_business_model_section:
        'Enter the business model of the company.',
    help_campaign_marketing_market_segment:
        'Enter the market segment of the company.',
    help_campaign_marketing_competition:
        'Enter the competition overview of the company.',
    campaign_marketing_asset_information_label: 'Label',
    help_campaign_marketing_asset_information_label:
        'Enter the label for this asset information row (e.g. "Investment Product").',
    campaign_marketing_asset_information_value: 'Value',
    help_campaign_marketing_asset_information_value:
        'Enter the value for this asset information row (e.g. "Subordinated Loan").',
    campaign_marketing_key_fact_label: 'Key Fact Label',
    help_campaign_marketing_key_fact_label: 'Enter the label of the key fact.',
    campaign_marketing_key_fact_value: 'Key Fact Value',
    help_campaign_marketing_key_fact_value: 'Enter the value of the key fact.',
    campaign_marketing_key_facts_note: 'Key Facts Note',
    help_campaign_marketing_key_facts_note:
        'Enter an additional note to display alongside the key facts.',
    campaign_marketing_risk_disclaimer: 'Risk Disclaimer',
    help_campaign_marketing_risk_disclaimer:
        'Enter the risk disclaimer for this campaign.',
    campaign_marketing_white_label_box: 'White Label Box',
    campaign_marketing_white_label_box_title: 'White Label Box Title',
    help_campaign_marketing_white_label_box_title:
        'Enter the title of the white label box.',
    campaign_marketing_white_label_box_icon: 'White Label Box Icon',
    help_campaign_marketing_white_label_box_icon:
        'Enter the name of the Lucide icon to render (e.g. "shield-check").',
    campaign_marketing_white_label_box_description:
        'White Label Box Description',
    help_campaign_marketing_white_label_box_description:
        'Enter the description of the white label box.',
    campaign_marketing_milestone_label: 'Milestone Label',
    help_campaign_marketing_milestone_label:
        'Enter the label of the milestone.',
    campaign_marketing_milestone_value: 'Milestone Value',
    help_campaign_marketing_milestone_value:
        'Enter the value of the milestone.',
    campaign_marketing_offering_title: 'Offering Title',
    help_campaign_marketing_offering_title: 'Enter the title of the offering.',
    campaign_marketing_offering_description: 'Offering Description',
    help_campaign_marketing_offering_description:
        'Enter the description of the offering.',
    campaign_marketing_revenue_structure_title: 'Revenue Structure Title',
    help_campaign_marketing_revenue_structure_title:
        'Enter the title of the revenue structure item.',
    campaign_marketing_revenue_structure_description:
        'Revenue Structure Description',
    help_campaign_marketing_revenue_structure_description:
        'Enter the description of the revenue structure item.',
    campaign_marketing_revenue_structure_percentage: 'Percentage',
    help_campaign_marketing_revenue_structure_percentage:
        'Enter the percentage share of this revenue structure item.',
    campaign_marketing_competitive_advantage_title:
        'Competitive Advantage Title',
    help_campaign_marketing_competitive_advantage_title:
        'Enter the title of the competitive advantage.',
    campaign_marketing_competitive_advantage_description:
        'Competitive Advantage Description',
    help_campaign_marketing_competitive_advantage_description:
        'Enter the description of the competitive advantage.',
    campaign_marketing_trend_title: 'Trend Title',
    help_campaign_marketing_trend_title: 'Enter the title of the trend.',
    campaign_marketing_trend_description: 'Trend Description',
    help_campaign_marketing_trend_description:
        'Enter the description of the trend.',
    campaign_marketing_swot_title: 'SWOT Title',
    help_campaign_marketing_swot_title: 'Enter the title of the SWOT item.',
    campaign_marketing_swot_description: 'SWOT Description',
    help_campaign_marketing_swot_description:
        'Enter the description of the SWOT item.',
    campaign_marketing_swot_type: 'SWOT Type',
    help_campaign_marketing_swot_type:
        'Select whether this is a positive (Strength/Opportunity) or negative (Weakness/Threat) point.',
    campaign_marketing_swot_type_success: 'Positive (Strength/Opportunity)',
    campaign_marketing_swot_type_error: 'Negative (Weakness/Threat)',
    campaign_marketing_financials_projections: 'Financials & projections',
    campaign_marketing_past_financial_figures: 'Past financial figures',
    campaign_marketing_financial_introduction: 'Introduction',
    help_campaign_marketing_financial_introduction:
        'Enter the introductory text shown above the financial tables.',
    campaign_marketing_financial_table_number: 'Table {number}',
    campaign_marketing_financial_table_title: 'Table Title',
    help_campaign_marketing_financial_table_title:
        'Enter the title of this financial table.',
    campaign_marketing_financial_table_note: 'Note',
    help_campaign_marketing_financial_table_note:
        'Enter an optional note shown below this table (e.g. "As of January 2026").',
    campaign_marketing_financial_item: 'Item',
    campaign_marketing_financial_add_period: 'Add Period',
    campaign_marketing_financial_add_row: 'Add Row',
    campaign_marketing_financial_add_table: 'Add Table',
    campaign_marketing_current_status: 'Current status',
    help_campaign_marketing_current_status:
        'Enter a short summary of the current status of the campaign.',
    campaign_marketing_current_status_box_label: 'Label',
    help_campaign_marketing_current_status_box_label:
        'Enter the label shown above the value (e.g. "Total liabilities").',
    campaign_marketing_current_status_box_value: 'Value',
    help_campaign_marketing_current_status_box_value:
        'Enter the value shown for this box (e.g. "2,180,000 €").',
    campaign_marketing_current_status_box_sublabel: 'Sublabel',
    help_campaign_marketing_current_status_box_sublabel:
        'Enter the sublabel shown below the value (e.g. "as of 28.02.2026").',
    campaign_marketing_projections_strategy: 'Projections & strategy',
    campaign_marketing_use_of_funds: 'Use of funds',
    campaign_marketing_use_of_funds_description: 'Description',
    help_campaign_marketing_use_of_funds_description:
        'Enter a short description of how the raised funds will be used.',
    campaign_marketing_use_of_funds_total: 'Total capital required',
    help_campaign_marketing_use_of_funds_total:
        'Enter the total capital required for this project.',
    campaign_marketing_use_of_funds_threshold: 'Minimum (funding threshold)',
    help_campaign_marketing_use_of_funds_threshold:
        'Enter the minimum funding threshold for this project.',
    campaign_marketing_use_of_funds_fully_funded: 'Fully funded (target / cap)',
    help_campaign_marketing_use_of_funds_fully_funded:
        'Enter the fully funded target/cap amount for this project.',
    campaign_marketing_use_of_funds_item_label: 'Label',
    help_campaign_marketing_use_of_funds_item_label:
        'Enter the label for this use-of-funds item (e.g. "Investment in new production facility").',
    campaign_marketing_use_of_funds_item_minimum_percentage:
        'Minimum scenario %',
    help_campaign_marketing_use_of_funds_item_minimum_percentage:
        'Enter the percentage allocated to this item in the minimum-funding scenario.',
    campaign_marketing_use_of_funds_item_full_percentage: 'Fully funded %',
    help_campaign_marketing_use_of_funds_item_full_percentage:
        'Enter the percentage allocated to this item in the fully-funded scenario.',
    campaign_marketing_use_of_funds_item_minimum_badge:
        'Minimum scenario badge',
    help_campaign_marketing_use_of_funds_item_minimum_badge:
        'Optionally mark how this item is affected in the minimum-funding scenario.',
    campaign_marketing_use_of_funds_item_full_badge: 'Fully funded badge',
    help_campaign_marketing_use_of_funds_item_full_badge:
        'Optionally mark how this item is affected in the fully-funded scenario.',
    campaign_marketing_use_of_funds_add_item: 'Add item',
    campaign_marketing_sustainability: 'Sustainability',
    campaign_marketing_esg_score: 'ESG score',
    help_campaign_marketing_esg_score:
        'Enter the ESG score as a percentage (decimals allowed, e.g. 82.6).',
    campaign_marketing_esg_description: 'Description',
    help_campaign_marketing_esg_description:
        'Enter a short description shown below the ESG score progress bar.',
    campaign_marketing_esg_card_title: 'Title',
    help_campaign_marketing_esg_card_title:
        'Enter the title for this ESG card (e.g. "Environment", "Social", "Governance").',
    campaign_marketing_esg_card_description: 'Description',
    help_campaign_marketing_esg_card_description:
        'Enter the description for this ESG card.',
    sdg_goal_1: 'No Poverty',
    sdg_goal_2: 'Zero Hunger',
    sdg_goal_3: 'Good Health and Well-being',
    sdg_goal_4: 'Quality Education',
    sdg_goal_5: 'Gender Equality',
    sdg_goal_6: 'Clean Water and Sanitation',
    sdg_goal_7: 'Affordable and Clean Energy',
    sdg_goal_8: 'Decent Work and Economic Growth',
    sdg_goal_9: 'Industry, Innovation and Infrastructure',
    sdg_goal_10: 'Reduced Inequalities',
    sdg_goal_11: 'Sustainable Cities and Communities',
    sdg_goal_12: 'Responsible Consumption and Production',
    sdg_goal_13: 'Climate Action',
    sdg_goal_14: 'Life Below Water',
    sdg_goal_15: 'Life on Land',
    sdg_goal_16: 'Peace, Justice and Strong Institutions',
    sdg_goal_17: 'Partnerships for the Goals',
    campaign_marketing_esg_sdgs: 'SDGs',
    campaign_marketing_esg_sdg_number: 'SDG',
    help_campaign_marketing_esg_sdg_number:
        'Select the UN Sustainable Development Goal this card represents.',
    campaign_marketing_esg_sdg_description: 'Description',
    help_campaign_marketing_esg_sdg_description:
        'Enter a short description of how this project supports this SDG.',
    campaign_marketing_esg_document: 'ESG document',
    campaign_marketing_esg_document_file: 'Document',
    help_campaign_marketing_esg_document_file:
        'Upload the ESG report as a PDF file.',
    toast_error_document_upload_failed:
        'The file "{file}" could not be uploaded. Please try again.',
    toast_error_document_upload_invalid_type:
        'This file type is not supported. Allowed file types: {accepted}',
    signature_feature_active: 'Signature feature active',
    help_signature_feature_active:
        'When activated, the asset can use signature feature',
    agio_disagio_feature_active: 'Agio/Disagio feature active',
    help_agio_disagio_feature_active:
        'When activated, the platform can use Agio/Disagio feature',
    add_order_certificate: 'Add Order Certificate',
    modal_title_delete_certificates: 'Delete certificates',
    sign_all_documents: 'Sign all documents at once',
    help_sign_all_documents:
        'When activated, all documents will be signed at once in signteq Iframes. This is useful for assets that have a lot of documents to sign.',
    webhook_calls: 'Webhook calls',
    help_webhook_calls_table:
        'Here you can view all webhook calls and filter them by platform and status.',
    last_attempted_at: 'Last attempted at',
    payload: 'Payload',
    attempt_number: 'Attempt number',
    attempt: 'Attempt',
    modal_title_view_webhook_call: 'View webhook call',
    help_webhooks_activated:
        'When activated you can configure webhooks for the platform.',
    user_tracking_history: 'User tracking history',
    user_tracking: 'User tracking',
    help_user_tracking_table:
        'The user tracking table where you can see user actions history',
    issuer_country: 'Issuer country',
    investor_country: 'Investor country',
    create_formula_amount: 'Create Tax Amount Formula',
    create_formula_rate: 'Create Tax Rate Formula',
    edit_tax: 'Edit tax',
    tax_formula_amount: 'Tax amount formula',
    tax_formula_rate: 'Tax rate formula',
    rate: 'Rate',
    formula: 'Formula',
    create_formula: 'Create formula',
    tax_detail_name_required: 'Tax detail name is required',
    platform_tax_documents: 'Platform Tax Documents',
    help_platform_tax_documents_table:
        'Here you can manage multilingual platform tax documents',
    modal_title_update_platform_tax_document: 'Update Platform Tax Document',
    modal_title_create_platform_tax_document: 'Create Platform Tax Document',
    modal_title_delete_platform_tax_document: 'Delete Platform Tax Document',
    modal_title_delete_platform_tax_documents: 'Delete Platform Tax Documents',
    toast_success_platform_tax_document_deleted:
        'Platform tax document "{platformTaxDocument}" deleted!',
    platform_membership_documents: 'Platform Membership Documents',
    help_platform_membership_documents_table:
        'Here you can manage multilingual platform membership documents',
    modal_title_update_platform_membership_document:
        'Update Platform Membership Document',
    modal_title_create_platform_membership_document:
        'Create Platform Membership Document',
    modal_title_delete_platform_membership_document:
        'Delete Platform Membership Document',
    modal_title_delete_platform_membership_documents:
        'Delete Platform Membership Documents',
    toast_success_platform_membership_document_updated:
        'Platform membership document "{platformMembershipDocument}" updated!',
    toast_success_platform_membership_document_created:
        'Platform membership document "{platformMembershipDocument}" created!',
    toast_success_platform_membership_document_deleted:
        'Platform membership document "{platformMembershipDocument}" deleted!',
    toast_success_platform_membership_documents_deleted:
        'Platform membership documents "{platformMembershipDocuments}" deleted!',
    toast_success_platform_tax_document_updated:
        'Platform tax document "{platformTaxDocument}" updated!',
    toast_success_platform_tax_document_created:
        'Platform tax document "{platformTaxDocument}" created!',
    toast_success_platform_tax_documents_deleted:
        'Platform tax documents "{platformTaxDocuments}" deleted!',

    platform_acceptance_documents: 'Platform Acceptance Documents',
    help_platform_acceptance_documents_table:
        'Here you can manage multilingual platform acceptance documents',
    modal_title_update_platform_acceptance_document:
        'Update Platform Acceptance Document',
    modal_title_create_platform_acceptance_document:
        'Create Platform Acceptance Document',
    toast_success_platform_acceptance_document_updated:
        'Platform acceptance document "{platformAcceptanceDocument}" updated!',
    toast_success_platform_acceptance_document_created:
        'Platform acceptance document "{platformAcceptanceDocument}" created!',
    modal_title_delete_platform_acceptance_document:
        'Delete Platform Acceptance Document',
    toast_success_platform_acceptance_document_deleted:
        'Platform acceptance document "{platformAcceptanceDocument}" deleted!',
    toast_success_platform_acceptance_documents_deleted:
        'Platform acceptance documents "{platformAcceptanceDocuments}" deleted!',
    modal_title_delete_platform_acceptance_documents:
        'Delete Platform Acceptance Documents',

    platform_self_disclosure_forms: 'Platform Self Disclosure Forms',
    help_platform_self_disclosure_forms_table:
        'Here you can manage multilingual platform self disclosure forms',
    modal_title_update_platform_self_disclosure_form:
        'Update Platform Self Disclosure Form',
    modal_title_create_platform_self_disclosure_form:
        'Create Platform Self Disclosure Form',
    toast_success_platform_self_disclosure_form_updated:
        'Platform self disclosure form "{platformSelfDisclosureForm}" updated!',
    toast_success_platform_self_disclosure_form_created:
        'Platform self disclosure form "{platformSelfDisclosureForm}" created!',
    modal_title_delete_platform_self_disclosure_form:
        'Delete Platform Self Disclosure Form',
    toast_success_platform_self_disclosure_form_deleted:
        'Platform self disclosure form "{platformSelfDisclosureForm}" deleted!',
    modal_title_delete_platform_self_disclosure_forms:
        'Delete Platform Self Disclosure Forms',
    toast_success_platform_self_disclosure_forms_deleted:
        'Platform self disclosure forms "{platformSelfDisclosureForms}" deleted!',
    toast_signature_document_updated: 'Signature document updated!',
    audits: 'Audits',
    help_audits: 'Here you can view the audits of the model.',
    auditable_type: 'Auditable type',
    auditable_id: 'Auditable ID',
    old_values: 'Old values',
    new_values: 'New values',
    view_audit: 'View audit',
    user_id: 'User ID',
    user_agent: 'User Agent',
    ip_address: 'IP Address',
    payment_account: 'Payment Account',
    payment_accounts: 'Payment Accounts',
    sync_enabled: 'Sync enabled',
    help_sync_enabled: 'Toggle to activate the payment account sync.',
    uses_proxy: 'Uses proxy',
    help_uses_proxy: 'Toggle to activate the payment account proxy usage.',
    toast_success_payment_account_saved: 'Payment account saved successfully!',
    webhook_api_key: 'Webhook API key',
    help_webhook_api_key: 'API key used for webhooks authentication.',
    payment_reference_prefix: 'Payment reference prefix',
    help_payment_reference_prefix: 'Prefix added to payment references.',
    payment_endpoint: 'Payment endpoint',
    help_payment_endpoint: 'Endpoint URL for payment processing.',
    auth_endpoint: 'Auth endpoint',
    api_endpoint: 'API endpoint',
    help_api_endpoint: 'Endpoint URL for API access.',
    help_auth_endpoint: 'Endpoint URL for authentication.',
    api_token: 'API token',
    help_api_token: 'Token used for API authentication.',
    client_id: 'Client ID',
    help_client_id: 'The Client ID for API authentication.',
    client_secret: 'Client Secret',
    help_client_secret: 'The Client Secret for API authentication.',
    master_contract_id: 'Master Contract ID',
    help_master_contract_id:
        'ID of the master contract associated with this payment account.',
    checkout_template_id: 'Checkout Template ID',
    help_checkout_template_id: 'ID of the checkout template used for payments.',
    deposit_iban: 'Deposit IBAN',
    help_deposit_iban: 'IBAN used for deposits.',
    toast_success_payment_account_deleted:
        'Payment account deleted successfully!',
    deposit_bic: 'Deposit BIC',
    help_deposit_bic: 'BIC used for deposits.',
    limit_credit_card: 'Limit credit card',
    help_limit_credit_card: 'Limit for the credit card transactions.',
    limit_bank_transfer: 'Limit bank transfer',
    help_limit_bank_transfer: 'Limit for the bank transfer transactions.',
    deposit_account_holder_address: 'Deposit account holder address',
    help_deposit_account_holder_address:
        'Address of the deposit account holder.',
    deposit_account_holder_country: 'Deposit account holder country',
    help_deposit_account_holder_country:
        'Country of the deposit account holder.',
    healthcheck_wallet: 'Healthcheck Wallet',
    help_healthcheck_wallet: 'The wallet used for checking the API.',
    help_type: 'The type of the entity.',
    payment_account_details: 'Payment Account Details',
    toast_error_payment_account_not_saved:
        'Payment account could not be saved!',
    payment_account_platforms: 'Payment Account Platforms',
    help_name: 'The name of the payment account.',
    help_description: 'The description of the payment account.',
    payment_account_summary: 'Payment Account Summary',
    payment_account_assets: 'Payment Account Assets',
    help_payment_account:
        'The platform payment account can be override by setting a payment account in asset.',
    toast_error_payment_methods_required:
        'At least one payment method is required',
    toast_investment_max_is_greater_than_the_biggest_limit:
        'Investment max is greater than the limit of the available payment methods',
    limit: 'Limit',
    external_contract_id: 'External contract ID',
    help_external_contract_id:
        'The external contract ID from payment provider.',
    external_contract: 'External contract',
    can_deposit: 'Can deposit',
    help_can_deposit:
        'Toggle to activate the deposit functionality for the payment account.',
    can_withdraw: 'Can withdraw',
    help_can_withdraw:
        'Toggle to activate the withdrawal functionality for the payment account.',
    logo_url: 'Logo URL',
    help_logo_url: 'The URL of the logo of the payment account.',
    require_kyc_id_for_investments: 'Require KYC ID for investments',
    help_require_kyc_id_for_investments:
        'When activated, KYC ID is required for investors to do investments',
    require_bank_account_for_investments:
        'Require bank account for investments',
    help_require_bank_account_for_investments:
        'When activated, investors must have a bank account before they can invest',
    require_kyc_address_for_investments: 'Require KYC Address for investments',
    help_require_kyc_address_for_investments:
        'When activated, KYC Address is required for investors to do investments',
    require_kyc_tax_for_investments: 'Require KYC Tax for investments',
    help_require_kyc_tax_for_investments:
        'When activated, KYC Tax is required for investors to do investments',
    wallets: 'Wallets',
    full_name: 'Full Name',
    external_id: 'External ID',
    external_internal_id: 'External Internal ID',
    balance: 'Balance',
    are_you_sure_you_want_to_run_exclusive_acceptance:
        'Are you sure you want to run exclusive acceptance?',
    signteq_kyc_qes: 'Signteq QES (Qualified Electronic Signature)',
    help_signteq_kyc_qes:
        'Toggle to activate the Signteq QES (Qualified Electronic Signature).',
    payout_contract_id: 'Payout Contract ID',
    help_payout_contract_id: 'The payout contract ID from payment provider.',
    iban_verifications: 'IBAN Verifications',
    iban_verification_view: 'View IBAN Verification',
    data: 'Data',
    response_data: 'Response Data',
    wallet_type: 'Wallet Type',
    redirect_to_another_platform: 'Redirect to another platform',
    help_redirect_to_another_platform:
        'When activated, users trying to login or register this platform will be redirected to another platform.',
    redirection_url: 'Redirection URL',
    help_redirection_url:
        'The URL where users will be redirected when trying to login or register this platform.',
    redirection_settings: 'Redirection Settings',
    recalculate_kyc_flags: 'Recalculate KYC flags',
    toggle_manual_kyc: 'Toggle manual KYC',
    toast_success_kyc_flags_recalculated:
        'KYC flags recalculated successfully!',
    toast_error_kyc_flags_recalculation:
        'Error: could not recalculate KYC flags',
    toast_success_manual_kyc_toggled: 'Manual KYC toggled successfully!',
    toast_error_manual_kyc_toggled: 'Error: could not toggle manual KYC',
    redirect_on_login: 'Redirect on Login',
    help_redirect_on_login:
        'The users will be redirect to the other platform when clicking on Login button',
    redirect_on_register: 'Redirect on Register',
    help_redirect_on_register:
        'The users will be redirect to the other platform when clicking on Register button',
    limit_credit_card_order: 'Credit card payment limit for order',
    help_limit_credit_card_order:
        'Limit for the credit card transactions while investing.',
    limit_credit_card_deposit: 'Credit card payment limit for deposit',
    help_limit_credit_card_deposit:
        'Limit for the credit card transactions while depositing.',
    limit_bank_transfer_order: 'Bank transfer payment limit for order',
    help_limit_bank_transfer_order:
        'Limit for the bank transfer transactions while investing.',
    limit_bank_transfer_deposit: 'Bank transfer payment limit for deposit',
    help_limit_bank_transfer_deposit:
        'Limit for the bank transfer transactions while depositing.',
    limit_bank_transfer_withdrawal:
        'Bank transfer payment limit for withdrawal',
    help_limit_bank_transfer_withdrawal:
        'Limit for the bank transfer transactions while withdrawing.',
    asset_hide_payment_info: 'Hide payment info',
    help_asset_hide_payment_info:
        'When activated, the payment info will be hidden for asset on investment and order pages.',
    asset_revoke_accrual: 'Revoke Accrual Flag (Secupay)',
    help_asset_revoke_accrual:
        'When activated, the accrual flag will be removed during payment acceptance for this asset.',
    label_invoice_fee_to_distribute: 'Stakeholder fee to be distributed',
    help_invoice_fee_to_distribute:
        'Absolute invoice amount from Accounting. Used to override the contract/payment account default per acceptance. Entering 0 here removes that fee for this acceptance — this is only possible at acceptance, not when the transaction is first created.',
    label_configured_stakeholder_fee: 'Configured stakeholder fee',
    label_total_acceptance_amount: 'Total amount to be accepted',
    label_orders: 'orders',
    label_derived_fee_percentage: 'Derived fee percentage',
    label_stakeholder_fee_will_be_removed:
        'The stakeholder fee will be removed for this acceptance.',
    label_fee_input_mode_amount: 'Enter stakeholder amount',
    label_fee_input_mode_percentage: 'Enter fee percentage directly',
    label_fee_percentage_direct: 'Fee percentage',
    help_fee_percentage_direct:
        'Enter the fee percentage directly (0–100). Used to override the contract/payment account default per acceptance. Entering 0 here removes that fee for this acceptance — this is only possible at acceptance, not when the transaction is first created.',
    label_revoke_accrual_acceptance: 'Revoke accrual flag',
    help_revoke_accrual_acceptance:
        "Accrual is revoked if this is checked or if 'Revoke accrual' is already enabled on the asset. To guarantee accrual is not revoked, make sure it's unchecked in both places.",
    disable_campaigns_button: 'Disable campaign investment and detail button',
    help_disable_campaigns_button:
        'Toggle this to hide details and invest button.',
    modal_title_create_withdrawal: 'Create money withdrawal',
    withdraw_money: 'Withdraw money',
    error_withdrawal_amount_must_be_greater_than_0:
        'Withdrawal amount must be greater than 0',
    error_withdrawal_not_allowed: 'Withdrawal not allowed by payment account',
    error_bank_account_required: 'Bank account is required for withdrawal',
    error_withdrawal_amount_is_greater_than_balance:
        'Withdrawal amount is greater than balance',
    error_withdrawal_amount_is_greater_than_limit:
        'Withdrawal amount is greater than withdrawal limit set by payment account',
    bank_account: 'Bank account',
    toast_success_money_withdrawal_created:
        'Money withdrawal created successfully!',
    new_login_modal_translations: 'New login modal translations',
    stakeholder_payment: 'Stakeholder Payment',
    stakeholder_payment_disabled_at_payment_account:
        'Stakeholder payment is disabled for the payment account. Enable it first in the payment account settings if you want to use it at the contract level.',
    disable_stakeholder_payment: 'Disable Stakeholder Payment',
    help_disable_stakeholder_payment:
        'When enabled, stakeholder payment is disabled for this contract.',
    enable_stakeholder_payment: 'Enable Stakeholder Payment',
    help_enable_stakeholder_payment:
        'Enable or disable stakeholder payment for this payment account.',
    stakeholder_contract_id: 'Stakeholder Contract ID',
    help_stakeholder_contract_id:
        'The contract ID for the stakeholder payment from the payment provider.',
    stakeholder_fee: 'Stakeholder Fee',
    help_stakeholder_fee:
        'The stakeholder fee as a decimal (divide percentage by 100). E.g. for 0.25% enter 0.0025.',
    stakeholder_fee_configured_from_payment_account:
        'Stakeholder fee configured from payment account is {stakeholderFee}',
    kyb_settings: 'KYB settings',
    investor_profile_settings: 'Investor Profile',
    investor_profile_settings_override: 'Set custom values for this platform',
    investor_profile_settings_reset_to_parent:
        'Reset to parent platform values',
    personal_data: 'Personal Data',
    country_of_birth: 'Country of birth',
    city_of_birth: 'City of birth',
    gender: 'Gender',
    pep: 'Politically Exposed Person',
    field_visible: 'Show',
    field_required: 'Required',
    field_editable_after_kyc: 'Editable after KYC',
    company_account_creation_mail_receipents:
        'Company account creation mail receipents',
    company_account_document_submission_mail_receipents:
        'Company account document submission mail receipents',
    help_email_receipents:
        'Enter the email addresses of the recipients divided by new line',
    toast_error_money_withdrawal_created: 'Money withdrawal creation failed!',
    warning: 'Warning',
    warning_modal_text:
        'Are you sure you want to continue? this will {actionLabel}',
    continue: 'Continue',
    run_bulk_set_pending_orders: 'Run bulk set pending orders',
    run_bulk_set_paid_orders: 'Run bulk set paid orders',
    kyc_reset_threshold: 'KYC Reset Threshold (hours)',
    help_kyc_reset_threshold:
        'The number of hours after which the KYC process will be reset.(If not set, Default is 72 hours)',
    help_additional_fields:
        'Here you can mark which additional fields are required for the campaign. The following switches are for the mandatory entry of the respective fields.',
    show_depot_fields_on_profile_section:
        'Show depot fields on profile section',
    confetti_on_investment_completion: 'Confetti on investment completion',
    confetti_in_onboarding: 'Confetti in onboarding',
    customize: 'Customize',
    toast_success_page_saved: 'Page saved successfully!',
    config: 'Config',
    preview: 'Preview',
    change_image: 'Change image',
    click_to_choose_image: 'Click to choose image',
    media_library: 'Media library',
    uploading: 'Uploading',
    upload_new: 'Upload new',
    no_images_yet: 'No images yet',
    upload_your_first_image_using_the_button_above:
        'Upload your first image using the button above',
    edit_alt_text: 'Edit alt text',
    alt_text: 'Alt text',
    has_eyebrow: 'Has eyebrow',
    is_badge: 'Is badge',
    eyebrow_text: 'Eyebrow text',
    eyebrow_color: 'Eyebrow color',
    eyebrow_icon: 'Eyebrow icon',
    icon_class_name_example: 'Icon class name (e.g. "fa-solid fa-star")',
    cards: 'Cards',
    add_card: 'Add card',
    card: 'Card',
    icon: 'Icon',
    icon_background: 'Icon background',
    icon_color: 'Icon color',
    alignment: 'Alignment',
    orientation: 'Orientation',
    has_glow_effect: 'Show glow effect',
    card_layout_orientation: 'Card layout orientation',

    // Blog Posts
    blog_post: 'Blog Post',
    move_up: 'Move up',
    move_down: 'Move down',
    thumbnail: 'Thumbnail',
    help_blog_post_thumbnail: 'Thumbnail image shown for this post.',
    slug: 'Slug',
    category: 'Category',
    duration: 'Duration',
    author: 'Author',
    author_info: 'Author Info',
    body: 'Body',
    guest: 'Guest',
    youtube_link: 'YouTube Link',
    spotify_link: 'Spotify Link',
    apple_music_link: 'Apple Music Link',
    podcasts: 'Podcasts',
    blogs: 'Blogs',
    videos: 'Videos',
    guides: 'Guides',
    press_posts: 'Press',
    help_podcasts_table: 'Manage podcast episodes for this platform.',
    help_blogs_table: 'Manage blog posts for this platform.',
    help_videos_table: 'Manage video content for this platform.',
    help_guides_table: 'Manage guides for this platform.',
    help_press_posts_table: 'Manage press posts for this platform.',
    help_blog_post_slug:
        'Used in the URL. Prefilled from the title, but can be edited freely and stays unchanged when the title is edited later. Must be unique for this platform.',
    help_blog_post_body: 'Main content of the post.',
    published_at: 'Publish Date',
    help_blog_post_published_at:
        'When this post goes live. Leave empty to publish it immediately; pick a future date and time to schedule it instead.',
    blog_post_cta: 'Call-to-action button',
    cta_label: 'Button text',
    cta_url: 'Button link',
    cta_icon: 'Button icon',
    help_blog_post_cta_label:
        'Text on the button below the article, e.g. Invest now. Without text and link, no button is shown.',
    help_blog_post_cta_url:
        'A full URL (https://…) or a path on the website, e.g. /investments.',
    help_blog_post_cta_icon:
        'Name of a Lucide icon from lucide.dev/icons, e.g. arrow-right. Leave empty for the right arrow.',
    seo: 'SEO',
    og_title: 'OG Title',
    og_description: 'OG Description',
    og_image: 'OG Image',
    focus_keyword: 'Focus Keyword',
    help_blog_post_og_title:
        'Overrides the title used for social share previews. Defaults to the title if empty.',
    help_blog_post_og_description:
        'Overrides the description used for social share previews. Defaults to the preview if empty.',
    modal_title_create_blog_post: 'Create Blog Post',
    modal_title_update_blog_post: 'Update Blog Post',
    modal_title_delete_blog_post: 'Delete Blog Post',
    modal_title_delete_blog_posts: 'Delete Blog Posts',
    toast_success_blog_post_created: 'Blog post created!',
    toast_success_blog_post_updated: 'Blog post updated!',
    blog_post_translations: 'Translations',
    help_blog_post_translations:
        'Link this post to its translations. When readers switch the language on the website, they land directly on the matching translation.',
    blog_post_translation_select: 'Select a post',
    blog_post_translation_not_published: 'not published yet',
    blog_post_translation_link: 'Link',
    blog_post_translation_unlink: 'Unlink',
    toast_success_blog_post_translation_linked: 'Translation linked!',
    toast_success_blog_post_translation_unlinked: 'Translation unlinked!',
    campaign_translations: 'Language versions',
    help_campaign_translations:
        'Link the campaigns of this asset that are the same offer in another language. When visitors switch the language on the website, they land directly on the linked campaign; without one, they land on the investments overview.',
    campaign_translation_select: 'Select a campaign',
    campaign_translation_link: 'Link',
    campaign_translation_unlink: 'Unlink',
    campaign_translation_no_candidates:
        'No unlinked campaign of this asset in this language.',
    campaign_x_default: 'Default version (x-default)',
    help_campaign_x_default:
        'Shown by search engines to visitors whose language has no version. Without a choice, the German version is used.',
    campaign_x_default_none: 'Not set (German version)',
    toast_success_campaign_translation_linked: 'Language version linked!',
    toast_success_campaign_translation_unlinked: 'Language version unlinked!',
    toast_success_campaign_x_default_updated: 'Default version saved!',
    toast_success_blog_post_deleted: 'Blog post "{blogPost}" deleted!',
    toast_success_blog_posts_deleted: 'Blog posts "{blogPosts}" deleted!',

    // Secondary market
    order_books_table: 'Pre-emptive Rights Ledger',
    direction: 'Direction',
    source: 'Source',
    quantity: 'Quantity',
    PRE_EMPTIVE: 'Pre-emptive',
    SHARE: 'Share',
    ADMIN_ADJUSTMENT: 'Admin Adjustment',
    IMPORT: 'Import',
    INVESTMENT: 'Investment',
    SECONDARY_MARKET: 'Secondary Market',
    EXERCISE: 'Exercise',
    IN: 'Inflow',
    OUT: 'Outflow',
    secondary_market_listings: 'Marketplace Listings',
    secondary_market_buy_requests: 'Marketplace Buy Requests',
    help_listings_table:
        'Overview of all sell listings on the secondary market',
    pre_emptive: 'Pre-emptive Right',
    share: 'Share',
    share_campaign_link: 'Copy campaign link',
    status_open: 'Open',
    status_reserved: 'Reserved',
    status_sold: 'Sold',
    status_cancelled: 'Cancelled',
    status_expired: 'Expired',
    price_per_unit: 'Price per Unit',
    note: 'Note',
    modal_title_cancel_listing: 'Are you sure you want to cancel this listing?',
    toast_success_listing_cancelled: 'Listing successfully cancelled',
    create_listing: 'Create Listing',
    create_buy_request: 'Create Buy Request',
    modal_title_cancel_buy_request:
        'Are you sure you want to cancel this buy request?',
    sm_pre_emptive_rights_required:
        'Secondary Market - Pre-emptive Rights Required',
    secondary_market_settings: 'Secondary Market - Settings',
    sm_pre_emptive_rights: 'Pre-emptive Rights Required',
    help_sm_pre_emptive_rights:
        'An investment in this campaign is only possible if the buyer possesses the required pre-emptive rights.',
    secondary_market_offers: 'Purchase Requests',
    create_offer: 'Create Purchase Request',
    edit_offer: 'Edit Purchase Request',
    seller: 'Seller',
    buyer: 'Buyer',
    available_rights: 'Available Pre-emptive Rights',
    sm_transaction_fee: 'Marketplace Fee (%)',
    offer_status: 'Offer Status',
    offer_status_pending: 'Pending',
    offer_status_accepted: 'Accepted',
    offer_status_rejected: 'Rejected',
    offer_status_cancelled: 'Cancelled',
    offer_status_expired: 'Expired',
    transaction_status_initiated: 'Initiated',
    transaction_status_buyer_signed: 'Buyer signed',
    transaction_status_seller_signed: 'Seller signed',
    transaction_status_pending_payment: 'Pending payment',
    transaction_status_completed: 'Completed',
    transaction_status_waiting_for_approval: 'Waiting for approval',
    transaction_status_failed: 'Failed',
    pre_emptive_rights_table: 'Secondary Market - Pre-emptive Rights',
    help_pre_emptive_rights_table:
        'Lists individual investors and their assigned pre-emptive rights.',
    contract_document: 'Contract Document',
    tx_status_initiated: 'Initiated',
    tx_status_buyer_signed: 'Buyer signed',
    tx_status_seller_signed: 'Seller signed',
    tx_status_pending_payment: 'Pending Payment',
    tx_status_completed: 'Completed',
    tx_status_escalated: 'Escalated',
    tx_status_cancelled: 'Cancelled',
    tx_status_waiting_for_approval: 'Waiting for approval',
    transaction_status: 'Transaction Status',
    seller_signed_contract: 'Seller-Signed Contract',
    buyer_signed_contract: 'Buyer-Signed Contract',
    payment_receipt: 'Payment Receipt',
    payment_reference: 'Payment Reference',
    transaction_will_be_created_on_save:
        'A transaction will automatically be created upon saving.',
    offer_details: 'Purchase Request Details',
    transaction: 'Transaction',
    toast_success_offer_saved: 'Purchase request successfully saved!',
    regenerate: 'Regenerate',
    modal_title_regenerate_offer:
        'Are you sure you want to regenerate this purchase request?',
    toast_success_offer_regenerated:
        'Purchase request successfully regenerated',
    toast_error_cannot_regenerate_offer:
        'Cannot regenerate this purchase request',
    send_email: 'Send email',
    modal_title_send_offer_email: 'Manually trigger email',
    help_send_offer_email:
        'Resends the selected email for this offer, e.g. after a record was fixed up manually.',
    email_template_type: 'Email template',
    recipient_role: 'Recipient',
    role_buyer: 'Buyer',
    role_seller: 'Seller',
    send_email_option_offer_received_buy_request:
        'Offer received (on buy request)',
    sm_subscription_ratio: 'Subscription Ratio (Pre-emptive Rights per Share)',
    help_sm_subscription_ratio:
        'Number of required pre-emptive rights per share. This value determines the conversion factor (e.g., a value of 3 requires 9 pre-emptive rights for 3 shares; a value of 0.5 requires 1 pre-emptive right for 2 shares).',
    sm_tolerance_band: 'Tolerance Band (%)',
    help_sm_tolerance_band:
        'Allowed price deviation from the target price without triggering a warning',
    sm_exercise_campaign: 'Linked Exercise Campaign',
    help_sm_exercise_campaign:
        'ID of the target campaign for exercising pre-emptive rights',
    help_sm_transaction_fee: 'Transaction fee (0 means free of charge)',
    create_pre_emptive_rights: 'Add Pre-emptive Rights',
    edit_pre_emptive_rights: 'Edit Pre-emptive Rights',
    sm_signing_deadline: 'Signing Deadline (Days)',
    help_sm_signing_deadline:
        'Deadline in days for both parties to sign the contract',
    sm_payment_fulfillment_deadline: 'Payment Fulfillment Deadline (Days)',
    help_sm_payment_fulfillment_deadline:
        'Deadline in days for the buyer to transfer funds and upload the payment receipt',
    sm_payment_confirmation_deadline: 'Payment Confirmation Deadline (Days)',
    help_sm_payment_confirmation_deadline:
        'Deadline in days for the seller to confirm receipt of payment',
    sm_frontend_url: 'Secundary Market Frontend-URL',
    help_sm_frontend_url: 'Secundary Market website address',
    show_wallet_menu_item: 'Show "My Wallet" menu item',
    help_show_wallet_menu_item:
        'Shows or hides the "My Wallet" menu item in the investor dashboard.',
    show_news_menu_item: 'Show "News" menu item',
    help_show_news_menu_item:
        'Shows or hides the "News" menu item in the investor dashboard. The activity feed on the dashboard itself is not affected.',
    sm_trading_enabled: 'Trading Active',
    help_sm_trading_enabled:
        'When disabled, no new listings/buy requests can be created and no existing listings/buy requests can be accepted anymore. Transactions already in progress are not affected.',
    help_sm_trading_enabled_asset:
        'When disabled, no new listings/buy requests can be created for this asset and no existing listings/buy requests can be accepted anymore. Transactions already in progress are not affected.',
    sm_dashboard_marketplace_button_enabled:
        'Dashboard Button "Go to Marketplace"',
    help_sm_dashboard_marketplace_button_enabled:
        'Controls the visibility of the marketplace button on the Secondary Market frontend dashboard (not the navigation).',
    sm_dashboard_back_to_platform_button_enabled:
        'Dashboard Button "Back to Platform"',
    help_sm_dashboard_back_to_platform_button_enabled:
        'Controls the visibility of the "Back to Platform" button on the Secondary Market frontend dashboard (not the sidebar navigation link).',
    sm_marketplace: 'Secondary Marketplace',
    help_sm_marketplace:
        'Here you can activate the Secondary Marketplace setting.',
    sm_marketplace_listings_visible: 'Listings/Buy-Requests visible',
    help_sm_marketplace_listings_visible:
        'When disabled, existing listings and buy requests are no longer shown in the Secondary Market frontend (the Buy/Sell tabs disappear). Buttons to create new listings/buy requests remain separately controlled by "Trading Active".',
    user_feedback: 'User Feedback',
    user_feedback_provider: 'Feedback Widget',
    help_user_feedback_provider:
        'Selects which user feedback widget, if any, is shown on the frontend.',
    user_feedback_provider_none: 'None',
    PUSHFEEDBACK: 'PushFeedback',
    USERSNAP: 'Usersnap',
    user_feedback_pushfeedback_project: 'PushFeedback Project',
    help_user_feedback_pushfeedback_project:
        'The PushFeedback project identifier.',
    user_feedback_pushfeedback_api_key: 'PushFeedback API Key',
    help_user_feedback_pushfeedback_api_key:
        'The PushFeedback API key. Optional, depending on the project configuration.',
    user_feedback_usersnap_project_code: 'Usersnap Project Code',
    help_user_feedback_usersnap_project_code:
        'The Usersnap global project API key used to load the widget.',
    sm_risk_disclaimers_title: 'Risk Disclaimers (Checkout Phase 2)',
    sm_risk_disclaimers_help:
        'Reorder via drag and drop. All items must be accepted by the investor.',
    sm_add_risk_disclaimer: 'Add Disclaimer',
    sm_risk_text_placeholder: 'Enter risk text... *',
    sm_risk_url_placeholder: 'https://... (optional link)',
    sm_no_risk_disclaimers: 'No risk disclaimers configured.',
    sm_save_risk_disclaimers: 'Save Risk Disclaimers',
    sm_risk_validation_empty_text:
        'Please fill in the text for all risk disclaimers.',
    sm_risk_disclaimers_saved_success: 'Risk disclaimers saved successfully.',
    sm_risk_disclaimers_saved_error: 'Error saving risk disclaimers.',
    loading_preview: 'Loading preview',
    all_rows_valid: 'All rows are valid',
    invalid: 'Invalid',
    sm_required_base_data_fields: 'Required base data fields',
    sm_buyer_signature_position: 'Position of buyer signature',
    sm_seller_signature_position: 'Position of seller signature',
}
